{
  "Shadow observation": "影子运行",
  "(in": "（以",
  ") in": "）以",
  "Abort": "中止",
  "Account": "账户",
  "Add": "添加",
  "All": "全部",
  "Analysis": "策略分析",
  "at": "于",
  "Available": "可用",
  "Back": "返回",
  "Backtest": "回测",
  "Balance": "资产余额",
  "Bot": "机器人",
  "Cancel": "取消",
  "Chart": "行情图表",
  "close": "收盘",
  "Close": "关闭",
  "Color": "颜色",
  "Confirm": "确认",
  "Confirmation": "操作确认",
  "Copy": "复制",
  "Count": "次数",
  "Currency": "币种",
  "Daily": "每日",
  "Dashboard": "仪表盘",
  "Date": "日期",
  "Day": "日",
  "Details": "详情",
  "Direction": "买卖方向",
  "disabled": "已禁用",
  "enabled": "已启用",
  "Entries": "入场",
  "Failed to load data": "加载数据失败",
  "Filled": "已成交",
  "for": "用于",
  "General": "常规",
  "highest": "最高",
  "History": "历史记录",
  "in": "以",
  "Index": "序号",
  "Left": "左侧",
  "Limit": "限价",
  "Live": "实盘交易",
  "Login": "登录",
  "long": "做多",
  "Long": "做多",
  "lowest": "最低",
  "Mark": "标记",
  "Market": "市价",
  "Metric": "指标",
  "Metrics": "指标",
  "No": "否",
  "Offline": "离线",
  "on": "于",
  "Online": "在线",
  "open": "开盘",
  "Period": "周期",
  "Price": "价格",
  "Profit": "盈利",
  "Reason": "原因",
  "Refresh": "刷新",
  "Reload": "重新加载",
  "remaining": "剩余",
  "Right": "右侧",
  "Save": "保存",
  "Setting": "设置项",
  "Settings": "设置",
  "short": "做空",
  "Spot": "现货",
  "Strategy": "策略",
  "Submit": "提交",
  "Time": "时间",
  "Toggle Night Mode": "切换夜间模式",
  "Trade": "交易",
  "Type": "类型",
  "UI": "界面",
  "UI Version:": "界面版本：",
  "Unsupported": "未支持",
  "Value": "数值",
  "Version:": "版本：",
  "Yes": "是",
  "Language": "界面语言",
  "Config": "配置",
  "Results": "结果",
  "from ": "从 ",
  " to ": " 至 ",
  "since ": "开始于 ",
  "Entry": "入场",
  "Exit": "离场",
  "Summary": "汇总",
  "Min": "最小值",
  "Max": "最大值",
  "Median": "中位数",
  "adjustment": "仓位调整",
  "combined": "汇总",
  "running": "运行中",
  "spot": "现货",
  "margin": "保证金交易",
  "cross": "全仓",
  "success": "已完成",
  "failed": "失败",
  "pending": "等待中",
  "pairlist": "交易对评估",
  "download_data": "数据下载",
  "lookahead_analysis": "前视偏差分析",
  "recursive_analysis": "递归分析",
  "Research variant": "研究版本",
  "Dynamic thresholds and quantities": "动态门槛与数量",
  "Dynamic thresholds, quantities and periods": "动态门槛、数量与周期",
  "Startup method": "启动方式",
  "Wait for pullback": "等待回撤",
  "Small initial purchase": "先买少量",
  "Research costs and sizing": "研究费用与交易规模",
  "Slippage (fraction)": "滑点（小数）",
  "Base buy fraction": "基础买入比例",
  "Base sell fraction": "基础卖出比例",
  "Total equity": "总权益",
  "Total net profit": "总净收益",
  "Realized lot profit": "已实现批次利润",
  "Unrealized principal PnL": "本金浮盈亏",
  "Maximum drawdown": "最大回撤",
  "Principal TRX": "TRX 本金数量",
  "Warmup minutes": "预热分钟数",
  "Zero-interest benchmark ending equity": "零理财基准期末权益",
  "Hold TRX": "持有 TRX",
  "Hold cash": "持有现金",
  "Order profit and lot allocations": "订单收益与批次分配",
  "Purchases establish cost. Sales realize profit. Unsold quantities remain unrealized.": "买入形成成本，卖出实现利润；未卖出的数量继续计入浮盈亏。",
  "Net realized profit": "已实现净利润",
  "Cost established": "形成持仓成本",
  "Lot": "批次",
  "Allocated cost": "分摊成本",
  "Net proceeds": "净到账",
  "No filled orders in this interval": "该区间没有已成交订单",
  "Remaining principal lots": "剩余本金批次",
  "Unit cost including fees": "含费用单位成本",
  "Anchor": "成交锚点",
  "Cumulative trading turnover (USDT)": "累计交易额（USDT）",
  "C1 one-year buy and sell allocation comparison": "C1 一年买入／卖出比例对比",
  "C1 one-year buy and sell threshold comparison": "C1 一年买入／卖出门槛对比",
  "Reused saved control": "复用已保存的对照结果",
  "Cumulative trading fees (USDT)": "累计手续费（USDT）",
  "After credited rebates": "返佣后净额",
  "Trading turnover sums actual TRX buy and sell execution values. Trading fees show gross exchange charges, with net fees after credited rebates below. Both are in USDT and exclude stablecoin conversions and Earn operations. Missing saved values are shown as a dash.": "累计交易额为 TRX 实际买入成交额＋卖出成交额；累计手续费为交易所实扣费用，下方列出已到账返佣后的净额。两列单位均为 USDT，不含稳定币兑换、理财申购及赎回。历史保存值缺失时显示“—”。",
  "Remaining principal cost": "剩余本金成本",
  "Oldest remaining lot (days)": "最久未卖出批次（天）",
  "Initial cash wait (minutes)": "首次买入前等待（分钟）",
  "Parameters used for this result": "本次结果使用的参数",
  "Decision details": "决策详情",
  "Confirmation period (minutes)": "确认周期（分钟）",
  "Anchor at confirmation": "确认时锚点",
  "Threshold at confirmation": "确认时阈值",
  "Fill count": "成交次数",
  "Available cash": "可立即使用的现金",
  "Cost occupation": "本金成本占用率",
  "warming_up": "指标预热中",
  "signal_expired": "信号已过期",
  "paused": "已暂停",
  "Previous": "上一页",
  "Next": "下一页",
  "Return": "收益率",
  "Cash": "现金",
  "Side": "方向",
  "Quantity": "数量",
  "Buy": "买入",
  "Sell": "卖出",
  "Fixed periods, thresholds and fractions": "固定周期、门槛与比例",
  "Net fees after credited rebates": "返佣后净手续费",
  "Gross exchange fees": "交易所扣费",
  "Credited fee rebates": "已到账返佣",
  "Pending fee rebates": "待到账返佣",
  "Exchange buy fee (fraction)": "交易所买入费率（扣费前）",
  "Exchange sell fee (fraction)": "交易所卖出费率（扣费前）",
  "Fee rebate {ratio}%": "返佣 {ratio}%",
  "Order profit includes fee refunds credited by the end of this result. Pending refunds do not count as profit.": "订单利润包含截至本次回测结束已到账的费用返还；待到账返佣不计利润。",
  "Same-interval strategy comparison": "同区间策略对比",
  "Saved backtest comparison batches": "已保存的回测对比批次",
  "Same 1m data, virtual capital, startup method, fees, rebates and slippage; only the strategy variant differs.": "使用同一份 1m 数据、本金、启动方式、手续费、返佣和滑点设置，仅研究版本不同。",
  "View details": "查看明细",
  "Compared 1m candles": "本组使用的 1m K 线",
  "Research basics": "基本设置",
  "Confirmation timing": "确认周期与预热",
  "Signals and volatility": "买卖门槛与波动反馈",
  "Purchase and sale sizing": "买卖规模",
  "Fees, rebates and slippage": "手续费、返佣与滑点",
  "Execution constraints": "成交约束与尾仓处理",
  "Other recorded parameters": "其他已记录参数",
  "Parameter name": "参数名称",
  "Meaning": "含义",
  "Fixed variant": "固定",
  "Dynamic sizing variant": "动态数量",
  "Dynamic-period variant": "动态周期",
  "Uses this parameter": "使用",
  "Does not use this parameter": "不使用",
  "Uses this parameter conditionally": "条件使用",
  "Rule version identifier": "规则版本标识",
  "Selects the execution rules": "选择执行规则",
  "Chooses among period tiers": "按档位选择",
  "Uses only the first period": "仅使用第一项",
  "Used for warmup": "用于预热",
  "Used for warmup and volatility": "预热与波动估计",
  "Used for buy sizing and period tiers": "买入规模与周期选择",
  "Used for buy sizing": "动态买入规模",
  "Uses the threshold directly": "直接使用门槛",
  "Uses it as the base threshold": "作为基础门槛",
  "Uses the fraction directly": "直接按比例计算",
  "Uses it as the base fraction": "作为基础比例",
  "Condition: the fee rebate ratio must be greater than zero.": "条件：返佣比例大于 0。",
  "Variant applicability is not yet documented.": "版本适用范围尚未说明。",
  "Research rule version": "研究规则版本",
  "Identifies the accounting and execution rules saved with this run.": "标识本次回测使用的记账与执行规则版本。",
  "Use it to distinguish historical rule revisions. It is report metadata, not a buy or sell signal.": "用于区分不同历史规则版本，本身不决定何时买卖。",
  "Initial virtual capital": "初始虚拟本金",
  "The virtual USDT balance at the start of this backtest.": "本次回测开始时的虚拟 USDT 资金。",
  "Change Initial virtual USDT above and run again. Comparisons must use the same starting capital.": "在上方“初始虚拟资金（USDT）”中修改后重新运行。比较研究版本时需使用相同本金。",
  "Wait for pullback keeps cash until a buy signal; Small initial purchase uses the initial buy fraction. Change Startup method above.": "“等待回撤”先持有现金，出现买入信号再买；“先买少量”按初始买入比例建仓。在上方“启动方式”中选择。",
  "Fixed uses constant periods, thresholds and fractions. The other variants add dynamic thresholds and sizing, then dynamic periods.": "固定版本使用固定周期、门槛与比例；另外两种版本依次增加动态门槛与数量、动态周期。",
  "View each variant through View details in the comparison table. For a single run, disable the three-variant comparison and choose a variant above.": "通过对比表的“查看明细”切换研究版本。单独运行时，可取消三版本同区间比较，在上方选择一个版本。",
  "Confirmation period candidates": "候选确认周期",
  "Confirmation closes are derived from the 1m data on UTC boundaries. A 1m observation does not always trigger a trading decision.": "从 1m 数据按 UTC 边界确定较长周期的收盘确认时点；每分钟获取行情不代表每分钟都做买卖决策。",
  "Fixed and dynamic sizing use only the first period. Dynamic periods choose buy tiers from this list and a sell tier one step shorter, down to the first period. Edit Candidate periods above.": "固定版本和动态数量版本只用第一项。动态周期版本从列表选择买入档位，卖出选低一档，最低为第一项。在上方“候选周期”中修改。",
  "Volatility estimation window": "波动估计窗口",
  "Estimate volatility from this many past 1m log returns, normalized to an hour. This also determines initial warmup, including in the fixed variant.": "用最近这些分钟的 1m 对数收益率估计波动，并换算成小时尺度；它也决定启动预热长度，固定版本同样需要预热。",
  "A larger window smooths the estimate but reacts more slowly. Change Volatility window under Research costs and sizing.": "窗口越长，估计越平滑，但对新波动反应更慢。在“研究费用与交易规模”的“波动窗口”中修改。",
  "Period relaxation confirmation count": "周期缩短确认次数",
  "A switch to a shorter period requires this many consecutive schedule evaluations requesting a lower tier. A longer period takes effect immediately.": "连续达到这些次调度评估的降档要求后，才切换到更短周期；升到更长周期则立即生效。",
  "This counts schedule evaluations, not minutes or 1m candles. A higher count makes relaxation slower. Set it in the research configuration; there is no page input yet.": "这里计数的是调度评估次数，并非分钟数或 1m K 线根数。数值越大，缩短周期越慢。通过研究配置调整，当前页面暂无输入项。",
  "Base buy pullback threshold": "买入基础回撤门槛",
  "The required price decline from the shared execution anchor. For example, 1.2% requires price at or below 98.8% of the anchor.": "相对共用成交锚点需要下跌的比例。例如 1.2% 表示价格降到锚点的 98.8% 或更低。",
  "Fixed uses this threshold directly; dynamic variants add volatility and occupation adjustments. A higher value requires a deeper pullback. Edit Buy threshold above.": "固定版本直接使用该门槛；动态版本还叠加波动和资金占用反馈。数值越大，需等待更深回撤。在上方“买入基础门槛”中修改。",
  "Base sell rebound threshold": "卖出基础反弹门槛",
  "The required price rise from the shared execution anchor. Eligible principal lots must also pass the separate profit check.": "相对共用成交锚点需要上涨的比例。准备卖出的本金批次还必须通过独立的盈利检查。",
  "Fixed uses this threshold directly; dynamic variants adjust it. A higher value requires a larger rebound. Edit Sell threshold above.": "固定版本直接使用该门槛；动态版本会调整。数值越大，需等待更大反弹。在上方“卖出基础门槛”中修改。",
  "Dynamic threshold lower bound": "动态门槛下限",
  "The lowest permitted buy or sell threshold after dynamic adjustments.": "动态调整后，买入和卖出门槛允许的最低值。",
  "Increasing it prevents small price moves from triggering trades. It must not exceed the upper bound. Set it in the research configuration.": "调高可避免太小的涨跌触发交易，且不能高于上限。通过研究配置调整。",
  "Dynamic threshold upper bound": "动态门槛上限",
  "The highest permitted buy or sell threshold after dynamic adjustments.": "动态调整后，买入和卖出门槛允许的最高值。",
  "Decreasing it caps how far volatility can raise the threshold. It must not fall below the lower bound. Set it in the research configuration.": "调低可限制波动把门槛抬高的幅度，且不能低于下限。通过研究配置调整。",
  "High volatility reference": "高波动参考值",
  "An hourly-equivalent volatility reference, not a price-change trigger. Dynamic buy sizing uses current volatility divided by this value.": "换算为小时尺度的波动参考值，不是涨跌触发门槛。动态买入规模会使用“当前波动 ÷ 此参考值”。",
  "A lower reference reduces dynamic purchases at the same volatility. In dynamic periods, reaching it also raises the desired period tier by one. Set it in the research configuration.": "相同波动下，参考值越低，动态买入越少。动态周期版本中，达到它还会把期望周期提高一档。通过研究配置调整。",
  "Volatility threshold coefficient": "波动门槛系数",
  "Multiplies volatility scaled to the selected confirmation period before adding it to the buy and sell thresholds.": "将波动换算到所选确认周期后，乘以该系数，再加入买入和卖出门槛。",
  "A larger coefficient requires larger price moves in volatile markets; zero removes this threshold term. It does not disable dynamic sizing. Set it in the research configuration.": "系数越大，波动市场中要求的涨跌幅越大；设为 0 可去掉这项门槛反馈，动态数量逻辑仍保留。通过研究配置调整。",
  "Buy occupation coefficient": "买入占用反馈系数",
  "Adds coefficient × occupation to the buy threshold, slowing additions as more capital is tied up.": "将“系数 × 占用程度”加到买入门槛上，资金占用越高，继续加仓越谨慎。",
  "A larger coefficient requires a deeper pullback at the same occupation. The final threshold still respects its bounds. Set it in the research configuration.": "相同占用程度下，系数越大，要求的回撤越深；最终门槛仍受上下限约束。通过研究配置调整。",
  "Sell occupation coefficient": "卖出占用反馈系数",
  "Subtracts coefficient × occupation from the sell threshold, allowing an earlier rebound sale at high occupation.": "从卖出门槛减去“系数 × 占用程度”，占用越高，越容易在较小反弹时卖出。",
  "A larger coefficient lowers the sell signal threshold, but never bypasses the per-lot profit check. Set it in the research configuration.": "系数越大，卖出信号门槛越低，但仍需逐批满足盈利条件。通过研究配置调整。",
  "The base purchase budget is this fraction of deployable capital B, capped by free cash. It is not a fraction of remaining cash.": "以可部署本金 B 的这一比例作为基础买入预算，同时不超过可用现金；不是按剩余现金计算比例。",
  "Dynamic variants further adjust the budget for pullback depth, occupation and volatility. Price, fees and rounding determine TRX quantity. Change Base buy fraction under Research costs and sizing.": "动态版本还根据回撤深度、占用和波动调整预算，再由价格、手续费及精度确定 TRX 数量。在“研究费用与交易规模”的“基础买入比例”中修改。",
  "The base target is this fraction of current principal TRX, excluding retained interest TRX.": "以当前 TRX 本金数量的这一比例作为基础卖出目标，不包含保留的 TRX 利息。",
  "Initial purchase fraction": "初始买入比例",
  "Gross buy fee rate": "买入原始费率",
  "The full fee deducted when buying, before any rebate. It enters both cash usage and principal cost.": "买入时先扣取的全额手续费率，尚未减去返佣；同时计入现金支出与本金成本。",
  "Enter the gross exchange rate under Research costs and sizing. Do not halve it again for a 50% rebate; the rebate ratio is applied separately.": "在“研究费用与交易规模”中填写交易所原始费率。50% 返佣会另行计算，不应把这里再减半。",
  "Gross sell fee rate": "卖出原始费率",
  "The full fee deducted when selling, before any rebate. It affects net proceeds and the per-lot profit check.": "卖出时先扣取的全额手续费率，尚未减去返佣；影响净到账与逐批盈利检查。",
  "Enter the gross exchange rate under Research costs and sizing. Future rebates cannot qualify an otherwise losing sale.": "在“研究费用与交易规模”中填写交易所原始费率。未来返佣不能让当前亏损批次提前满足卖出条件。",
  "Fee self-rebate ratio": "手续费自返佣比例",
  "The share of paid fees returned as simulated USDT at daily settlement. Pending refunds are excluded from equity and free cash.": "已付手续费中，按日结算返还为模拟 USDT 的比例。未到账返佣不计权益和可用现金。",
  "For example, a 0.1% gross fee and 50% rebate give a 0.05% net fee after settlement. Set zero for no rebate. Change Fee rebate ratio under Research costs and sizing.": "例如原始费率 0.1%、返佣 50%，到账后净费率为 0.05%。设为 0 表示无返佣。在“研究费用与交易规模”的“自返佣比例”中修改。",
  "Daily rebate settlement time": "每日返佣结算时间",
  "The daily settlement hour in the configured rebate timezone. A fee refund is credited at the next occurrence of this hour after the fill.": "按返佣时区计算的每日结算小时。成交产生的返佣在成交后下一个该时点到账。",
  "00:00 means the next local midnight. Changing the hour changes when refunded funds become available. Set it in the research configuration.": "00:00 表示下一个当地午夜。修改时点会改变返佣资金何时可用。通过研究配置调整。",
  "Rebate settlement timezone": "返佣结算时区",
  "A fixed offset from UTC used to calculate rebate settlement. UTC+08:00 corresponds to Beijing time.": "用于计算返佣结算时间的固定 UTC 偏移。UTC+08:00 对应北京时间。",
  "This affects rebate timing only; candle and order timestamps remain displayed in UTC. Set it in the research configuration.": "它仅影响返佣时间，不改变 K 线和订单仍以 UTC 展示的时间。通过研究配置调整。",
  "Simulated execution slippage": "模拟成交滑点",
  "Buy fills use the next 1m open plus this percentage; sell fills use the next 1m open minus it.": "买入按下一根 1m K 线开盘价上浮该比例成交；卖出则下浮该比例。",
  "A larger value simulates worse fills and may cancel signals that no longer pass execution checks. It is separate from fees. Change Slippage under Research costs and sizing.": "数值越大，模拟成交越不利，也可能使信号无法通过执行复核而取消；滑点与手续费分别计算。在“研究费用与交易规模”的“滑点”中修改。",
  "Minimum order value": "最小订单金额",
  "The minimum quantity × price value for a simulated order, before fees.": "模拟订单“数量 × 价格”的最低金额，不含手续费。",
  "Smaller orders are skipped. This also helps identify untradable tails. Match the intended market rules in the research configuration.": "不足该金额的订单跳过，也用于判断无法单独交易的尾仓。通过研究配置匹配目标市场规则。",
  "Minimum order quantity": "最小订单数量",
  "The minimum TRX quantity for a simulated order. Zero means no additional quantity floor; the minimum order value still applies.": "模拟订单的最低 TRX 数量。0 表示不另设数量下限，但最小订单金额仍有效。",
  "Orders must satisfy both the quantity and value limits. Match the intended market rules in the research configuration.": "订单须同时满足数量与金额要求。通过研究配置匹配目标市场规则。",
  "TRX quantity decimal places": "TRX 数量小数位",
  "Order quantities are rounded down to this many decimal places, never rounded up.": "订单数量保留这些位小数，并向下截取，不向上取整。",
  "Fewer decimal places can leave more dust or bring an order below the minimum value. Match the intended market precision in the research configuration.": "小数位越少，可能留下更多零头，或让订单低于最小金额。通过研究配置匹配目标市场精度。",
  "Per-lot profit buffer": "逐批盈利安全余量",
  "A sale requires price after the gross sell fee to exceed that lot’s unit cost multiplied by one plus this buffer.": "卖出时，扣除原始卖出费率后的单位到账价，必须严格高于该批单位成本 ×（1 + 此余量）。",
  "This is a profitability buffer, not an extra fee. Increasing it requires more profit before selling; zero still requires a strictly profitable sale. Set it in the research configuration.": "它是盈利检查缓冲，不会额外扣费。调高需更多利润才能卖出；设为 0 仍要求严格盈利。通过研究配置调整。",
  "Maximum execution price deviation": "最大成交价格偏离",
  "The maximum absolute percentage difference between the simulated fill price and the signal price.": "模拟成交价相对信号价的百分比偏离绝对值上限。",
  "An order is canceled if the difference exceeds this limit. A smaller value is stricter; zero requires identical prices, rather than disabling the check. Set it in the research configuration.": "超过上限则取消订单。数值越小越严格；0 要求两价相同，不代表关闭检查。通过研究配置调整。",
  "Profitable tail completion": "盈利尾仓补齐",
  "If a normal sale would leave a small untradable principal tail, attempt to sell all free principal in that sale.": "若普通按比例卖出会留下无法单独交易的小额本金尾仓，尝试在本次卖出中补齐全部可用本金数量。",
  "Completion requires every affected lot to pass the profit check. Losing principal and retained interest are not cleared. Disable it to keep the usual proportional sale. Set it in the research configuration.": "只有涉及的所有批次均通过盈利检查才补齐；亏损本金和保留利息继续持有。关闭后维持通常的按比例卖出。通过研究配置调整。",
  "Enabled": "已启用",
  "Disabled": "已关闭",
  "1 minute": "1 分钟",
  "1 hour": "1 小时",
  "{count} hours": "{count} 小时",
  "{count} minutes": "{count} 分钟",
  "{value} coefficient": "{value}（系数）",
  "{value} (+{points} percentage points at full occupation)": "{value}（满占用时加 {points} 个百分点）",
  "{value} (−{points} percentage points at full occupation)": "{value}（满占用时减 {points} 个百分点）",
  "{count} consecutive schedule evaluations": "连续 {count} 次调度评估",
  "{count} decimal places": "{count} 位小数",
  "Wait for pullback does not make an initial purchase.": "等待回撤方式不进行首次少量建仓。",
  "The recorded rebate ratio is zero.": "本次记录的返佣比例为 0。",
  "This saved parameter has no description in this frontend version.": "当前前端版本尚未提供该已保存参数的说明。",
  "Its recorded value is shown unchanged. Check the matching research rule version before interpreting it.": "按原样展示已记录的取值，需结合对应研究规则版本理解。",
  "Historical Earn assumptions": "历史理财研究假设",
  "Historical Earn model": "历史理财模型",
  "APR": "年化利率",
  "No Earn": "不计理财收益",
  "Hourly TRX interest only": "仅 TRX 小时理财",
  "Simplified hourly TRX and USDGO interest": "TRX / USDGO 简化小时理财",
  "TRX research APR": "TRX 研究年化利率",
  "USDGO research APR": "USDGO 研究年化利率",
  "Historical strategy and Earn research": "历史策略与理财研究",
  "TRX APR {trx}%": "TRX 年化 {trx}%",
  "TRX APR {trx}% / USDGO APR {usdgo}%": "TRX 年化 {trx}% / USDGO 年化 {usdgo}%",
  "Earn model used by this batch": "本批次使用的理财口径",
  "Earn assumptions used by this result": "本次结果的理财口径",
  "Total equity includes credited Earn once. TRX interest is retained separately and is not sold with principal. USDGO credits enter deployable capital. The rates and conversion terms are simulated assumptions.": "总权益已包含到账理财收益，不再额外叠加。TRX 利息独立留存，不随本金卖出；USDGO 已到账利息加入可部署资金。利率及兑换条件均为模拟研究假设。",
  "Retained TRX interest (TRX)": "留存 TRX 利息（TRX）",
  "TRX interest value at credit (USDT)": "TRX 利息到账时价值（USDT）",
  "Retained TRX interest ending value (USDT)": "TRX 利息期末市值（USDT）",
  "Retained interest price PnL (USDT)": "留存利息价格盈亏（USDT）",
  "USDGO balance": "USDGO 余额",
  "Credited USDGO interest (USDGO)": "已到账 USDGO 利息（USDGO）",
  "Earn income (TRX at ending price)": "理财收益（TRX 按期末价）",
  "Benchmark ending equity with the same Earn assumptions": "相同理财假设下的基准期末权益",
  "Simulated hourly interest credits": "模拟小时派息明细",
  "Each row is a simulated credited payment. Eligible quantity excludes subscriptions that have not started accruing. Retained TRX interest remains exposed to TRX prices; credit-time value and ending market value can differ.": "每行是一笔模拟已到账派息。计息数量不含尚未起息的申购。留存 TRX 利息继续承担币价波动，因此到账时价值可能与期末市值不同。",
  "Eligible interest quantity": "有效计息数量",
  "Credited interest quantity": "到账利息数量",
  "Credit-time value (USDT)": "到账时价值（USDT）",
  "No hourly interest credits in this interval": "该区间暂无小时派息到账",
  "Select the model in Historical Earn assumptions above. The simplified model converts idle USDT to USDGO at 1:1 with zero exchange costs and instant redemption. It does not reconstruct actual historical products.": "在上方“历史理财研究假设”中选择。简化模型按 1:1、零兑换费用、即时赎回配置闲置 USDGO，未还原实际历史产品。",
  "Fixed annual simple-rate input. Each eligible full hour earns quantity × APR ÷ 365 ÷ 24. Received TRX is retained separately from principal.": "固定年化单利率输入。每个完整计息小时的收益 = 有效数量 × 年化利率 ÷ 365 ÷ 24。到账 TRX 与本金分开留存。",
  "Edit TRX APR above. Subscriptions start next hour and pay after that full hour; reinvested interest has the same delay. Redeemed quantities do not earn for the incomplete hour. TRX interest never funds a losing principal sale.": "在上方修改 TRX 年化利率。申购下一整点起息，经过完整一小时后派息，复投同样等待；当小时赎回数量不计该小时收益。TRX 利息不用于补贴亏损本金卖出。",
  "Edit USDGO APR above. The simplified model uses next-hour accrual and later hourly payment, with the same delay on reinvestment. Only eligible USDGO earns this income; USDT is not independently credited at this rate.": "在上方修改 USDGO 年化利率。简化模型下一整点起息，再按小时派息，复投同样等待。仅合格 USDGO 余额获得此收益，不同时给 USDT 余额重复计息。",
  "This result uses the zero-Earn model.": "本次结果使用零理财模型。",
  "Condition: the historical model includes TRX interest.": "条件：历史模型包含 TRX 理财。",
  "Deployable capital B includes starting capital, net external flows, realized principal profit, credited stablecoin interest and realized FX profit. Unrealized TRX gains and retained TRX interest do not create spendable cash. Occupation is the larger of TRX market-value share and remaining principal cost divided by B, capped at 100%.": "可部署本金 B 包含初始本金、净外部划入、已实现波段利润、已到账稳定币收益和已实现兑换损益。TRX 浮盈与留存 TRX 利息不会凭空增加可买入现金。占用程度取“TRX 市值占总权益比例”和“剩余本金成本 ÷ B”中较大的一项，上限 100%。",
  "Adjust this research input and rerun; recorded historical results do not change. These values are scenario assumptions, not verified account terms.": "调整研究参数后需重新运行，已保存历史结果不变；这些取值是情景假设，不是已核验的账户条件。",
  "Cash allocation and product assumptions": "现金配置与产品假设",
  "Strong-rebound sell coefficient": "卖出反弹强度系数",
  "Adds a bounded fraction when the rebound exceeds the signal threshold; 0.2 allows up to 20 extra percentage points at twice the threshold. Principal profit checks still apply.": "反弹超过触发门槛后增加卖出比例；0.2 表示反弹达到门槛两倍时最多额外加 20 个百分点，仍须逐批盈利。",
  "USDT alternative research APR": "USDT 替代研究年化",
  "The assumed hourly USDT yield when funds stay in USDT; cash allocation compares this alternative with USDGO after costs. Zero is an explicit research assumption.": "闲置 USDT 的假设小时收益率；择优配置将它与扣除成本后的 USDGO 收益比较。0 是明确的研究假设。",
  "Bounded cash forecast horizon": "现金收益预测窗口",
  "A preset forecast in hours, bounded to 30 days. It does not use the actual future interval until the next TRX purchase. Larger horizons can cover more conversion costs.": "预先设定的预测小时数，上限 30 天，不读取未来真实买入间隔。窗口越长，预计收益越可能覆盖兑换成本。",
  "Minimum cash conversion value": "最小现金切换金额",
  "Minimum USDT spend for a cash conversion, including after quota limits. Smaller balances remain in USDT rather than repeatedly exchanging dust.": "现金兑换的最低 USDT 支出，额度限制后的实际金额也须达标；更小余额保留为 USDT，避免零头反复兑换。",
  "Required net switching benefit": "净切换收益余量",
  "USDGO expected proceeds must exceed staying in USDT by this amount after both FX legs, spreads, slippage and accrual gaps. Zero still requires a strictly positive benefit.": "扣除双边兑换费用、价差、滑点、计息空档后，USDGO 预计结果须比继续持有 USDT 多出此金额。0 仍要求净增益严格为正。",
  "Cash reconversion cooldown": "现金反向再配置等待",
  "After redemption for a TRX purchase, delay reinvesting leftover cash into USDGO by these minutes. Valid TRX purchase funding can interrupt the hold.": "为 TRX 买入赎回后，剩余现金需等待这些分钟再转入 USDGO；有效的 TRX 买入资金需求可打断保持条件。",
  "USDGO research reference price": "USDGO 研究参考价",
  "USDT value of one USDGO. Bid and ask are derived from this reference and the spread; existing USDGO is valued at the reference, not automatically at one.": "每 1 USDGO 的 USDT 估值。参考价与价差共同生成买卖报价；已有 USDGO 按此价格估值，不自动永远记作 1。",
  "Full research FX spread": "研究兑换双边价差",
  "The total bid/ask spread as a fraction of the reference; each side uses half. A larger spread raises roundtrip costs and can prevent a cash switch.": "买卖报价总价差占参考价的比例，两侧各用一半。价差增大会增加往返成本，也可能让切换不再合格。",
  "Effective research FX fee": "研究兑换净费率",
  "Effective fee charged on each FX leg. It is already the modeled final cost and receives no additional TRX rebate, preventing a second deduction of the rebate.": "每次兑换实际承担的净费用率，已作为模型最终成本，不再额外套用 TRX 返佣，避免把返佣重复减两次。",
  "Research FX slippage": "研究兑换滑点",
  "Worsens each FX quote by this fraction. It enters both forecast and actual simulated exchange once, separately from the spread and fee.": "按此比例恶化每侧兑换报价。预测与模拟实际兑换各按同一规则计算一次，与价差和手续费分别计入。",
  "Research FX quantity precision": "研究兑换数量精度",
  "USDGO conversion quantities round down to these decimal places. This is simulation precision, not a verified exchange market rule.": "USDGO 兑换数量向下截取到这些小数位；这是模拟精度，不是已核验的交易所精度。",
  "Maximum permitted USDGO deviation": "USDGO 允许价格偏离",
  "Stop new USDGO expansion or purchase-funding conversions when the reference deviates from one by more than this fraction. Holdings stay listed and are valued at the known price.": "参考价偏离 1 超过此比例时，停止新增 USDGO 配置及相关买入资金兑换；已有资产继续列账并按已知价格估值。",
  "Simulated redemption arrival delay": "模拟赎回到账等待",
  "Minutes until assets requested for a trade become available. The plan must still be valid at arrival; expiry releases reservations without an invented fill.": "为交易准备的资产经过这些分钟才可用。到账后仍须满足信号与盈利条件；过期则释放预留，不虚构成交。",
  "USDGO quote availability assumption": "USDGO 报价可用假设",
  "Models a usable FX quote. Missing quotes pause dependent conversions and USDGO income valuation; they are not treated as a free executable exchange.": "模拟是否存在可用兑换报价。缺报价时暂停依赖它的兑换和 USDGO 收益计价，不能把未知当作可免费成交。",
  "Injected FX deviation timing": "场景偏离注入时点",
  "Minutes from this run’s beginning until an external FX shock. The cash forecast sees only the current quote and never anticipates the injection.": "从本次起点经过这些分钟后，注入外部价格偏离情景；现金预测只使用当前报价，不提前利用该注入时点。",
  "Injected FX reference price": "场景偏离注入价格",
  "The reference price after a scenario shock. Zero disables the injection; a positive value changes valuation at the configured time without forcing liquidation.": "情景偏离后的参考价。0 表示关闭注入；正数在设定时点改变估值，不强制亏损清仓。",
  "TRX product availability assumption": "TRX 理财可用假设",
  "If unavailable, TRX remains held without that modeled yield. Product unavailability alone does not reject an otherwise valid principal purchase.": "不可用时，TRX 继续持有但不计此路径收益；不能仅因为理财不可用而拒绝合格的本金买入。",
  "USDGO product availability assumption": "USDGO 理财可用假设",
  "If unavailable, stop new net-benefit allocations to USDGO and do not credit its modeled income. Existing assets are not automatically liquidated.": "不可用时，停止择优模型中的新增 USDGO 配置并不计其模拟收益；已有资产不自动清仓。",
  "Eligible TRX interest quantity cap": "TRX 合格计息数量上限",
  "Maximum TRX quantity receiving the modeled APR. Zero means no research limit; excess quantity stays owned but earns no additional modeled income.": "享受模型年化的 TRX 数量上限。0 表示研究中不设上限；超出部分仍归账户持有，但不额外计算该路径收益。",
  "USDGO subscription and interest cap": "USDGO 申购与计息上限",
  "Maximum USDGO allocation and eligible interest base. Zero means no research limit; unused funds may remain in USDT.": "USDGO 配置与有效计息基数的上限。0 表示研究中不设上限；未使用的资金可以保留在 USDT。",
  "Dynamic thresholds only": "仅动态门槛",
  "Dynamic quantities only": "仅动态数量",
  "Dynamic periods only": "仅动态周期",
  "Dynamic thresholds and periods": "动态门槛与周期",
  "Dynamic quantities and periods": "动态数量与周期",
  "Dynamic": "动态",
  "Fixed": "固定",
  "candles": "根 K 线",
  "Hourly Earn with net-benefit cash allocation": "按净增益择优配置的小时理财",
  "Threshold, quantity and period mechanism validation": "门槛、数量、周期机制验证",
  "Saved mechanism validation batches": "已保存的机制验证批次",
  "Experiment combination": "实验组合",
  "Threshold mechanism": "门槛机制",
  "Quantity mechanism": "数量机制",
  "Period mechanism": "周期机制",
  "Mean TRX exposure": "平均 TRX 市值仓位",
  "Average marginal mechanism effects": "机制平均边际影响",
  "Mechanism": "机制",
  "Mean net-profit change (USDT)": "平均净收益变化（USDT）",
  "Mean return change (percentage points)": "平均收益率变化（百分点）",
  "Mean drawdown change (percentage points)": "平均最大回撤变化（百分点）",
  "Matched mechanism pairs": "查看逐对机制对照",
  "Baseline combination": "基准组合",
  "Enabled combination": "开启该机制后",
  "Net-profit change (USDT)": "净收益变化（USDT）",
  "Drawdown change (percentage points)": "最大回撤变化（百分点）",
  "Chronological segment diagnosis": "按时间分段的历史诊断",
  "Stress scenarios for the complete dynamic mechanism": "全动态机制的压力情景",
  "Scenario": "情景",
  "Zero Earn scenario": "零理财收益",
  "Half APR scenario": "理财年化减半",
  "Higher spot costs scenario": "现货费率及滑点提高",
  "FX friction scenario": "增加兑换费用、价差及滑点",
  "60-minute redemption scenario": "赎回等待 60 分钟",
  "USDGO 3% deviation scenario": "USDGO 中途偏离 3%",
  "Eight combinations use identical data and non-mechanism parameters. Each pair changes one mechanism switch; interactions with other enabled mechanisms can remain. No coefficient search was performed.": "8 种组合使用完全相同的数据与其余参数。每对比较只改变一个机制开关，其它已开启机制可能产生交互影响；本批次未进行系数搜索。",
  "This is retrospective diagnosis on already observed history, not a genuinely unseen holdout or live approval. Segment runs reset virtual capital and the anchor; their profits must not be added as one continuous portfolio.": "这是对已观察历史的回顾诊断，不能宣称严格未见样本或实盘验收。各分段重置虚拟本金与锚点，不能把分段利润相加当成一个连续账户收益。",
  "Each mechanism has four matched on/off pairs. Positive profit or return changes increase performance in this sample; negative drawdown changes reduce drawdown. The averages are context-dependent, not guaranteed future improvements.": "每个机制均有 4 对开启／关闭对照。收益变化为正表示本样本中收益增加，回撤变化为负表示回撤降低；这些平均值依赖其它机制状态，不保证未来改善。",
  "This interval is too short for two quarterly segments; only full-interval and stress diagnosis are available.": "本区间不足以形成两段季度窗口，仅提供全区间机制与压力诊断。",
  "This combination uses fixed thresholds.": "本组合使用固定门槛。",
  "This combination uses fixed fractions.": "本组合使用固定比例。",
  "Only dynamic sizing or period selection uses this volatility reference.": "仅动态数量或动态周期使用该波动参考值。",
  "This parameter is only used by net-benefit cash allocation.": "该参数仅用于按净增益择优配置的模型。",
  "No FX deviation is injected in this saved scenario.": "本次情景未注入价格偏离。",
  "This combination uses fixed confirmation periods.": "本组合使用固定确认周期。",
  "This model does not include USDGO interest.": "本模型不计 USDGO 利息。",
  "Condition: use net-benefit cash allocation.": "条件：使用按净增益择优配置的模型。",
  "Condition: simulated Earn is enabled.": "条件：已开启模拟理财。",
  "Condition: a positive FX shock rate is configured in the net-benefit scenario.": "条件：择优模型中已设置正数的偏离注入价格。",
  "Condition: the model includes USDGO interest.": "条件：模型包含 USDGO 理财。",
  "Dynamic sizing adds 0.4 × occupation and a bounded boost for rebounds beyond the signal threshold, capped at 100%. Profitable lots can reduce the sale and tail completion can increase it. Change Base sell fraction under Research costs and sizing.": "动态数量在基础比例上增加“0.4 × 占用程度”和超过门槛的反弹反馈，上限 100%。合格盈利量可减少实际卖出，尾仓补齐可增加。基础比例在上方研究设置中修改。",
  "Interest disposal accounted separately": "利息处置单独计账",
  "Selects zero Earn, hourly TRX interest only, simplified hourly TRX and USDGO, or the cash net-benefit hourly model. All eight trading combinations support these research models.": "选择不计理财、仅计 TRX 小时利息、TRX 与 USDGO 简化小时模型，或现金净收益小时模型。八种交易组合均支持这些研究模型。",
  "Fixed annual simple-rate input for eligible simulated USDGO. Hourly credits use the recorded research exchange rate and increase deployable capital; the simplified model fixes that rate at 1:1.": "模拟 USDGO 的固定年化单利输入，仅合格份额计息。小时派息按记录的研究兑换价格估值并增加可投资资金；简化模型固定按 1:1 估值。",
  "Cash net-benefit hourly model": "现金净收益小时模型",
  "Buy / sell orders": "买入／卖出订单数",
  "If redemption takes longer than a signal remains valid, the order expires. A scenario with no TRX trades and zero drawdown is a cash-only outcome, not evidence of superior trading.": "赎回等待超过信号有效期时，订单会失效。若没有任何 TRX 成交且回撤为零，只说明这一情景一直持有现金，不能据此认定交易策略更优。",
  "Beijing time (UTC+8)": "北京时间（UTC+8）",
  "Display and input timezone": "显示与输入时区",
  "Time ({zone})": "时间（{zone}）",
  "Buy count": "买入次数",
  "Sell count": "卖出次数",
  "Backtest diagnosis": "回测诊断",
  "Export this research package": "导出本批研究包",
  "Observed historical research": "已观察历史研究",
  "Loading diagnosis": "正在读取诊断",
  "Diagnosis loading timed out. Your saved result is unchanged; retry loading.": "读取诊断超时，已保存的回测结果未改变，请点击重试。",
  "Retry loading diagnosis": "重新读取诊断",
  "Not collected; rerun required": "未采集，需要重跑",
  "Rerun diagnosis with the saved parameters and data": "按当次参数与同一数据重跑诊断",
  "No TRX wave execution; cash income only": "未执行波段，仅现金收益",
  "Trading activity": "交易活跃度",
  "Signal outcomes": "信号去向",
  "Actual thresholds and periods": "实际门槛与周期",
  "Order sizing and lots": "交易金额与本金批次",
  "Drawdown review": "回撤复盘",
  "Income reconciliation": "收益分解与核对",
  "Earn and conversion traces": "理财、兑换与赎回",
  "Month": "月份",
  "Independent buy signals": "独立买入信号",
  "Independent sell signals": "独立卖出信号",
  "Submitted buy orders": "提交买单",
  "Submitted sell orders": "提交卖单",
  "Buy fills": "买入成交片段",
  "Sell fills": "卖出成交片段",
  "Active trading days": "活跃交易天数",
  "View month": "查看当月",
  "Longest interval without principal execution": "最长本金无成交区间",
  "Median / longest execution interval (minutes)": "成交间隔中位数／最长间隔（分钟）",
  "Close evaluations": "收盘评估",
  "Independent signals": "独立信号",
  "Eligible": "通过资格检查",
  "Awaiting funds": "等待资金",
  "Submitted orders": "提交订单",
  "Executed decisions": "已成交决策",
  "Fill fragments": "成交片段",
  "No signal": "没有形成信号",
  "Signals without execution": "有信号但未成交",
  "Primary reason": "主要终止原因",
  "Actual threshold": "实际门槛",
  "Price change from anchor": "相对锚点的价格变化",
  "Anchor after execution": "完成成交后的锚点",
  "Capital occupation": "资金占用反馈",
  "TRX exposure": "TRX 实际敞口",
  "Deployable capital": "可部署本金",
  "USDGO awaiting redemption": "赎回中的 USDGO",
  "Retained interest TRX": "留存利息 TRX",
  "Profitable quantity": "合格盈利数量",
  "Profitable lots": "合格盈利批次数",
  "Planned notional": "计划成交金额",
  "Constrained notional": "约束后的金额",
  "Executed notional": "实际成交金额",
  "Planned quantity": "计划数量",
  "Target quantity": "约束后的数量",
  "Executed quantity": "实际成交数量",
  "Sizing factor": "数量调整因子",
  "Funds ready at": "资金可执行时间",
  "Signal expires at": "信号到期时间",
  "Virtual submission time": "模拟订单提交时间",
  "Opportunity ended at": "机会终止时间",
  "Final status": "最终状态",
  "Additional restrictions": "附加限制",
  "Repeated signal checks": "同一信号重复检查次数",
  "Base threshold": "基础门槛",
  "Volatility adjustment": "波动调整",
  "Occupation adjustment": "仓位调整",
  "Threshold before clipping": "截断前门槛",
  "Clipped at lower limit": "触及门槛下限",
  "Clipped at upper limit": "触及门槛上限",
  "Previous confirmation period": "上次确认周期",
  "Previous anchor": "成交前锚点",
  "Current anchor": "成交后锚点",
  "Anchor source": "锚点来源",
  "Related decision ID": "关联交易决策 ID",
  "Original quantity": "原始数量",
  "Remaining quantity": "剩余数量",
  "Sold quantity": "已卖数量",
  "Unit cost": "单位成本",
  "Unrealized principal P&L": "本金未实现盈亏",
  "Realized principal profit": "本金已实现净利润",
  "Holding time (minutes)": "持有时间（分钟）",
  "Ordinary sale eligible": "满足普通卖出资格",
  "Operation": "资金操作",
  "Asset": "币种",
  "Accrual starts at": "起息时间",
  "Expected arrival": "预计到账时间",
  "Credited at": "实际入账时间",
  "Received amount": "实际收到金额",
  "Paid amount": "实际支付金额",
  "Execution rate": "实际兑换价格",
  "Cost at execution rate": "兑换综合成本（相对当时估值）",
  "Entry conversion cost": "申购兑换综合成本",
  "Observed exit cost": "已发生换回成本",
  "Observed total conversion cost": "已发生兑换总成本",
  "Attributed interest quantity": "归属的实际利息数量",
  "Attributed interest value": "归属的实际利息价值",
  "Last redemption time": "最后赎回时间",
  "Complete roundtrip cost recovered": "完成周期的往返成本已覆盖",
  "Interest covers observed costs": "利息覆盖已发生成本",
  "Forecast at conversion": "兑换时的收益预测",
  "Attribution convention": "收益归属口径",
  "Redeemed quantity": "已赎回数量",
  "Signal formed": "信号已形成",
  "Funds ready": "资金就绪",
  "Submitted": "已提交",
  "Executed": "已成交",
  "Not executed": "未成交",
  "Ineligible": "未通过资格检查",
  "Partially executed and closed": "部分成交后终止",
  "Still held": "仍未退出",
  "Exited": "已退出",
  "Incomplete cycle": "未完成周期",
  "Completed cycle": "已完成周期",
  "No net-profitable lot": "没有净盈利批次",
  "Below minimum quantity": "低于最小交易数量",
  "Below minimum notional": "低于最小订单金额",
  "No deployable cash": "没有可部署现金",
  "Assets present but unavailable for funding": "有理财资产但不具备资金执行条件",
  "Signal expired": "信号过期",
  "Execution price deviated too far": "执行价格偏离过大",
  "Price condition no longer met": "执行时价格条件失效",
  "No net profit after execution costs": "重新计入费用后不再盈利",
  "No next candle to execute": "数据结束，缺少下一根执行 K 线",
  "Not a selected confirmation close": "不是所选周期的收盘时点",
  "Insufficient change from anchor": "相对锚点的变化不足",
  "Warming up": "预热中",
  "Principal empty, waiting": "本金空仓等待",
  "Only interest TRX remains": "仅剩利息 TRX",
  "Principal held normally": "正常持有本金",
  "Capital nearly fully occupied": "资金接近用满",
  "Subscription": "理财申购",
  "Complete accrual hour": "完整计息小时",
  "Interest credited": "派息入账",
  "Redemption requested": "赎回申请",
  "Redemption arrived": "赎回到账",
  "Redemption cancelled": "赎回取消并恢复申购",
  "Redeemed asset executed": "赎回资产完成成交",
  "Realized principal wave profit": "本金已实现波段净利润",
  "TRX interest value when credited": "TRX 利息入账时价值",
  "TRX interest subsequent price P&L": "TRX 利息后续价格盈亏",
  "Stablecoin interest": "稳定币理财利息",
  "Realized conversion P&L": "稳定币兑换已实现损益",
  "Unrealized conversion P&L": "稳定币兑换未实现损益",
  "Initial confirmed close": "首次确认收盘价",
  "Principal execution VWAP": "本金实际成交均价",
  "Fixed confirmation period": "固定确认周期",
  "Occupation or volatility tier": "仓位或波动档位变化",
  "Perspective": "统计视角",
  "P90": "90% 分位数",
  "Maximum": "最大值",
  "At lower limit": "处于下限的时间比例",
  "At upper limit": "处于上限的时间比例",
  "By runtime": "按运行时间",
  "By close evaluation": "按收盘评估次数",
  "Period switches": "周期切换",
  "Anchor changes": "锚点变化",
  "Planned → constrained → executed notional": "计划金额 → 约束后金额 → 实际成交金额",
  "Median executed notional": "每笔成交金额中位数",
  "Median share of deployable capital": "每笔占可部署本金比例中位数",
  "Losing principal cost locked": "亏损本金占用金额",
  "Principal cost held over 30 days": "持有超过 30 天的本金成本",
  "Median / longest duration of exited lots (minutes)": "已退出批次持有时间中位数／最长（分钟）",
  "Median / longest duration of remaining lots (minutes)": "未退出批次持有时间中位数／最长（分钟）",
  "Longest no-trade interval": "最长无交易区间",
  "Review longest no-trade interval": "复盘最长无交易区间",
  "Equity peak": "权益高点",
  "Equity trough": "权益低点",
  "Recovery": "恢复时间",
  "Decline minutes": "下跌时长（分钟）",
  "Recovery minutes": "恢复时长（分钟）",
  "Not recovered": "尚未恢复",
  "Review": "复盘",
  "Equity change after net deposits": "剔除净入金后的权益变化",
  "Reconciliation residual": "总账核对差额",
  "Earn operations": "理财申赎与派息流水",
  "Conversion executions": "逐次兑换记录",
  "Conversion holding cycles": "兑换持有周期",
  "Saved record detail": "本次保存的记录详情",
  "Synchronized interval review": "区间同步复盘",
  "Interval executions": "区间成交记录",
  "Interval signals": "区间信号记录",
  "Balances at first / last sampled close": "区间首尾收盘资金状态",
  "Recorded balance changes in this interval": "区间账本累计值变化",
  "No-trade intervals in this month": "当月无成交区间",
  "Principal TRX value": "本金 TRX 市值",
  "Interest TRX value": "利息 TRX 市值",
  "Stablecoin value": "稳定币资产市值",
  "No records in this interval": "此区间没有记录",
  "Controlled parameter comparisons and benchmarks": "受控参数对比与公平基准",
  "Saved baseline": "已保存基准结果",
  "One parameter group": "一次调整一组参数",
  "Candidate values, comma separated": "候选值，用逗号分隔",
  "Run controlled comparison": "运行受控对比",
  "Baseline value": "基准参数值",
  "Inherit research variant": "沿用研究版本设置",
  "Saved controlled comparison batches": "已保存的受控对比批次",
  "Candidate": "候选方案",
  "Return change": "收益率变化",
  "Drawdown change": "最大回撤变化",
  "Executed buy / sell notional": "累计买入／卖出金额",
  "Earn contribution": "理财收益贡献",
  "Baseline": "基准",
  "Research drawdown filter (%)": "研究回撤筛选（%）",
  "Highest return within filter": "筛选内收益率最高方案",
  "No eligible wave strategy": "没有符合条件的波段方案",
  "Compatible passive benchmarks": "相同假设下的被动基准",
  "Hold USDT with compatible interest": "仅持有 USDT 并按配置生息",
  "Hold USDGO with compatible interest": "仅持有 USDGO 并按配置生息",
  "Hold TRX with compatible Earn": "持有 TRX 并参加同样理财",
  "Simple 25% initial TRX allocation": "初始 25% 本金买入 TRX 后持有",
  "Cash-only benchmark": "仅现金资产基准",
  "Dynamic buy sizing": "动态买入数量",
  "Dynamic sell sizing": "动态卖出数量",
  "Zero Earn independent rerun": "关闭理财独立重跑",
  "Use true or false for sizing switches": "数量开关请输入 true 或 false",
  "Enter one to five valid candidate values": "请输入 1～5 个有效候选值",
  "Record ID": "流水 ID",
  "Diagnostics observe one continuous replay and never change trading rules. Old records are not backfilled.": "诊断来自一次连续回放，只记录事实，不改变买卖规则。旧结果不会补造记录。",
  "A new result is saved only if the original trades, equity and drawdown can be reproduced.": "仅在原成交、权益与回撤能够逐项复现时保存新诊断结果。",
  "Monthly counts slice a continuous replay; capital and anchor are never reset.": "按月切分同一次连续回测，本金与锚点不会重新初始化。",
  "Repeated checks of a persistent signal share one opportunity ID. Each opportunity has one final primary reason; additional restrictions are tags.": "持续存在的同一信号共用一个机会 ID；每个机会只保留一个最终主要原因，其他限制作为附加标签。",
  "Submission is virtual. This OHLCV model does not simulate exchange rejection or orderbook partial fills.": "提交订单属于历史模拟。当前 K 线模型不模拟交易所拒单和盘口部分成交。",
  "Time-weighted conditions and decision-weighted conditions are separate distributions. Details show base, volatility, occupation and clipping.": "按时间与按收盘评估次数分别统计；明细展示基础门槛、波动调整、仓位调整和最终截断。",
  "USDGO Earn and redemption balances are assets, not instantly deployable cash. Retained TRX interest contributes to NAV and exposure but is excluded from ordinary principal sales.": "理财及赎回中的 USDGO 是资产，不能当作即时现金；留存 TRX 利息计入权益和敞口，普通本金卖出不会出售它。",
  "Largest drawdowns use every minute of equity. Click to inspect prices, exposure, trades and unexecuted signals; the system does not infer a cause.": "回撤按逐分钟权益计算。点击查看价格、敞口、成交及未成交信号；系统展示事实，不预先推断原因。",
  "Components already include booked fees and credited rebates. Do not deduct or add them again. A zero-Earn rerun follows a different reinvestment and trading path.": "收益分项已经计入费用及到账返佣，不可再次扣减或加回。关闭理财重跑会改变复投和后续交易路径。",
  "Subscriptions, full accrual hours, credited interest, redemption requests, arrivals and cancellations are linked to decision IDs.": "理财申购、完整计息小时、派息到账、赎回申请、到账与取消均可关联交易决策。",
  "USDGO interest is attributed pro rata across eligible conversion cohorts. Waiting withdrawals use LIFO, then eligible withdrawals use pro rata. Incomplete cycles omit future exit costs.": "USDGO 利息按合格计息数量比例归属兑换批次；赎回先扣待起息批次（后进先出），再按比例扣已起息批次。未完成周期不预估未来换回成本。",
  "The chart is sampled for display; drawdowns and exports use full minute records.": "图表为展示采样；回撤计算及研究包保留完整逐分钟记录。",
  "Select the currently displayed saved result as baseline. Each batch changes one group only, saves all effective parameters, and preserves previous studies.": "以当前展示的已保存结果为基准，一批只调整一组参数。保存完整实际参数，旧实验结果不覆盖。",
  "Observed historical research; previously inspected data is not an unseen validation set. Forward paper simulation remains a separate mode.": "当前属于已观察历史研究；已查看并据此调参的数据不能标成未见验证集。前向纸面模拟为独立模式。",
  "Ratios use decimals: 0.012 = 1.2%. Sizing switches use true / false.": "比例用小数：0.012 表示 1.2%；数量开关用 true／false。",
  "This filters historical outcomes and adds no stop-loss. Cash-only results remain visible but are excluded from wave-strategy ranking.": "此阈值仅筛选历史结果，不增加策略止损。仅现金收益结果保留展示，但不参与波段策略排名。",
  "Same data, initial capital, warmup, costs, product eligibility and hourly accrual. TRX benchmarks buy once and keep inventory; USDGO passive allocation respects costs and quotas. USDT uses its configured APR.": "使用相同数据、本金、预热、费用、产品资格与小时计息。TRX 基准一次买入后持有；USDGO 遵守兑换成本和额度；USDT 使用当次配置年化。",
  "Dynamic buy sizing override": "动态买入数量独立开关",
  "Dynamic sell sizing override": "动态卖出数量独立开关",
  "Null inherits the variant; true enables only dynamic buy sizing; false disables it.": "空值沿用研究版本；true 仅启用动态买入数量，false 关闭动态买入数量。",
  "Null inherits the variant; true enables only dynamic sell sizing; false disables it.": "空值沿用研究版本；true 仅启用动态卖出数量，false 关闭动态卖出数量。",
  "Change this independently in a controlled comparison; sell sizing remains as saved.": "在受控对比中单独调整，卖出数量规则沿用保存的配置。",
  "Change this independently in a controlled comparison; buy sizing remains as saved.": "在受控对比中单独调整，买入数量规则沿用保存的配置。",
  "Minutes": "分钟",
  "start": "开始时间",
  "end": "结束时间",
  "minutes": "分钟",
  "evaluations": "收盘评估次数",
  "signals": "独立信号数",
  "cash": "USDT 现金",
  "free_cash": "可立即使用的 USDT",
  "usdgo_value": "USDGO 市值",
  "redemption_usdgo_value": "赎回中的 USDGO 市值",
  "gross_fees": "交易所实扣手续费",
  "credited_rebates": "到账返佣",
  "trx_interest_value": "留存 TRX 利息市值",
  "lot_changes": "批次浮盈亏变化",
  "peak_at": "权益高点时间",
  "trough_at": "权益低点时间",
  "recovered_at": "恢复时间",
  "end_at": "复盘结束时间",
  "drawdown": "回撤",
  "met": "满足价格条件",
  "Saved diagnostic research results": "已采集诊断的研究结果",
  "Buy base threshold": "买入基础门槛",
  "Sell base threshold": "卖出基础门槛",
  "Buy allocation fraction": "买入基础比例",
  "Sell allocation fraction": "卖出基础比例",
  "last_attempt": "同一机会最后一次信号检查",
  "peak_quantity": "高点持有数量",
  "peak_cost": "高点持仓成本",
  "trough_quantity": "低点持有数量",
  "trough_cost": "低点持仓成本",
  "unrealized_change": "浮盈亏变化",
  "Lot P&L changes include interval trades and credited rebates, not price changes alone.": "批次浮盈亏变化包含区间买卖和到账返佣影响，不等同于单纯的价格贡献。",
  "roundtrip_cost": "预计往返成本",
  "forecast_hours": "预测持有时长（小时）",
  "amount": "预测资金金额",
  "mark": "当时 USDGO 估值",
  "eligible": "符合兑换条件",
  "spend": "预计支付金额",
  "days": "天",
  "records": "条记录",
  "original_cost": "本金批次原始买入成本（含到账返佣调整）",
  "original_unit_cost": "原始单位成本（含到账返佣调整）",
  "Warmup and waiting checks": "预热与等待状态检查（分钟次数）",
  "Collected {count} minute closes; buy and sell evaluations occur only at their selected confirmation closes.": "已记录 {count} 次 1m 收盘；正式买卖评估只在各自选定的确认周期收盘进行。",
  "fx_profit": "稳定币兑换已实现损益",
  "Drawdown": "回撤幅度",
  "Lot ID": "本金批次 ID",
  "equity": "总权益",
  "buy_threshold": "实际买入门槛",
  "sell_threshold": "实际卖出门槛",
  "buy_period": "买入确认周期（分钟）",
  "sell_period": "卖出确认周期（分钟）",
  "state": "资金状态",
  "decline_minutes": "下跌时长（分钟）",
  "recovery_minutes": "恢复时长（分钟）",
  "tier": "当前周期档位",
  "due_at": "预计到账时间",
  "Execution preflight": "执行前价格与资金预估",
  "Restricted buy-reference recovery": "受限买入参考恢复",
  "Sell sizing inventory basis": "卖出数量计算基数",
  "Maximum profitable inventory sale fraction": "单次出售比例上限",
  "All principal inventory": "全部本金库存",
  "Eligible profitable inventory": "合格盈利库存",
  "Common terms, 12% buy allocation": "共同条件基准：买入比例 12%",
  "P0: preflight, 12% buy allocation": "P0：执行前预估，买入比例 12%",
  "P1: 8% buy allocation": "P1：买入比例 8%",
  "P1: 6% buy allocation": "P1：买入比例 6%",
  "P2: 8% with restricted recovery": "P2：8%＋受限参考恢复",
  "P3: 8% with profitable inventory sizing": "P3：8%＋合格库存出售",
  "Combined recovery and inventory experiment": "恢复与出售节奏组合验证",
  "Pressure baseline, 8% allocation": "压力环境：8% 基准",
  "Pressure combined experiment": "压力环境：组合验证",
  "Focused allocation, recovery and inventory study": "本轮聚焦实验：买入规模、参考恢复与出售节奏",
  "Seven fixed cases: common baseline, preflight, 8%, 6%, restricted recovery, profitable inventory sales and combined verification. A paired conservative pressure case is saved separately.": "固定七组：共同基准、执行前预估、8%、6%、受限参考恢复、合格库存出售、组合验证；另保存一组基准与组合的保守压力对照。",
  "Uses the 2026-10-13 ordinary APR snapshot with tiered interest. Research assumptions: 5,000 TRX / 1,000 USDGO eligible caps; 1-minute redemptions for TRX, USDGO and USDT; FX fee 0.05%, full spread 0.05%, slippage 0.02%. These are not verified account terms.": "采用 2026-10-13 普通活期 APR 快照并按额度分档计息。研究假设：合格额度 5,000 TRX／1,000 USDGO；TRX、USDGO、USDT 赎回等待 1 分钟；兑换手续费 0.05%、完整价差 0.05%、滑点 0.02%。这些是研究参数，不是已核实的账户条款。",
  "Recovery starts after 30 inactive days, freezes a buy reference for 7 days, caps one recovery purchase at 2%, and cools down for 7 days. Old lot costs remain unchanged. The selected result supplies the exact data interval and other strategy settings.": "连续 30 天没有本金成交后，满足条件才启用参考恢复；参考冻结 7 天、恢复买入最多使用可部署本金的 2%、冷却 7 天。老批次保留真实成本。数据区间及其他策略参数取自当前选中的已保存结果。",
  "Run focused research protocol": "运行本轮聚焦实验",
  "Research environment": "研究环境",
  "Ordinary APR snapshot scenario": "普通活期 APR 快照情景",
  "Half APR, restricted quotas, 60-minute redemption pressure": "利率减半、额度收紧、赎回等待 60 分钟压力情景",
  "Changes are measured against each row’s named control. Pressure results are compared only within their own environment. Historical research does not select or activate a live strategy.": "变化值相对于各行标明的对照组计算；压力结果只在同一环境内比较。本批属于历史研究，不自动选定或启用实盘策略。",
  "Comparison control": "对照组",
  "Benchmark curves display hourly samples. Downloads contain every minute of NAV and funds. The 25% benchmark buys once and lets exposure drift; it is not constant-weight rebalancing.": "基准图按小时抽样展示；下载文件包含每分钟净值和资金状态。25% 基准只在初始买入一次，后续仓位随价格变化，不进行恒定比例再平衡。",
  "Full minute NAV": "完整分钟净值",
  "Download minute NAV CSV": "下载逐分钟净值 CSV",
  "Focused research rules": "本轮研究规则与利率快照",
  "Apply these inputs to a separately saved research result; account operations remain disabled.": "用于独立保存的研究结果，真实账户操作继续保持未启用。",
  "Recovery inactivity days": "参考恢复的无成交天数",
  "Recovery reference validity days": "恢复参考有效天数",
  "Recovery cooldown days": "参考恢复冷却天数",
  "Recovery purchase maximum fraction": "恢复买入预算上限",
  "TRX research APR tiers": "TRX 年化利率分档",
  "USDGO research APR tiers": "USDGO 年化利率分档",
  "USDT research APR tiers": "USDT 年化利率分档",
  "APR snapshot source": "利率快照来源",
  "APR observation time in UTC": "利率采集时间（UTC）",
  "APR pressure multiplier": "利率压力倍数",
  "USDT research redemption delay": "USDT 研究赎回等待",
  "Uses the flat research APR": "使用单一研究 APR",
  "Before funding, estimate executable prices using the closed price and configured slippage; reject unprofitable inventory and redemption deadlines that cannot be met. Final execution checks still apply.": "资金准备前，使用已闭合价格及配置的滑点预估执行条件；过滤不盈利库存和无法在信号有效期内到账的赎回。实际成交前继续严格复核。",
  "After prolonged principal inactivity, allow one bounded purchase against a frozen auxiliary reference. Actual fill anchors and old lot costs are retained.": "长期没有本金成交后，允许基于冻结的辅助买入参考进行一次受限买入；实际成交锚点和老批次成本继续保留。",
  "Minimum continuous days without a principal fill before considering recovery.": "启用参考恢复前，必须连续没有本金成交的最短天数。",
  "Freeze the activation close as the buy reference for this many days; no reference chasing within the window.": "使用启动时已闭合的价格作为买入参考，在有效期内冻结，不追随价格抬高。",
  "After expiration or a principal fill, wait this many days before another recovery activation.": "参考失效或完成本金成交后，在此冷却期结束前不再次启用恢复。",
  "The recovery budget is the smaller of the normal buy budget and this share of deployable capital; available funds and market minimums still apply.": "恢复预算取正常买入预算与可部署本金乘此比例的较小值；还要满足可用资金、精度和最小订单条件。",
  "Principal uses all principal TRX for the sale target. Profitable uses only available lots eligible after fees and the execution margin.": "全部本金模式以全部本金 TRX 计算卖出目标；合格库存模式只使用扣费并满足执行余量后盈利、且可执行的本金批次。",
  "Caps the final sell share after occupation and rebound feedback. This is an independent experiment; it does not create a permanent inventory floor.": "对仓位和反弹反馈后的最终出售比例设置上限，作为独立实验参数。",
  "Each cumulative coin quantity cap has an annual rate. Quantities above recorded rate coverage receive no unverified interest.": "每个累计币种数量上限对应一个年化利率，分档计算；超过已记录利率覆盖范围的数量不计未经核实的利息。",
  "Public quote source and frozen snapshot hash, not verified account entitlement or historical rates.": "记录公开报价来源及冻结快照的校验值，不代表已核实账户资格或历史利率。",
  "Time this public rate snapshot was saved. Historical replay uses a fixed scenario, not a reconstructed rate series.": "本次公开利率快照的保存时间；历史回放采用固定情景，并非还原过去每小时的真实利率。",
  "Multiply every flat or tiered rate by this factor for a separately saved pressure scenario.": "将单一或分档利率全部乘以此倍数，用于独立保存的压力情景。",
  "USDT participating in Earn is reserved during redemption, cannot fund a purchase before arrival, and stops accruing while reserved.": "参加理财的 USDT 在赎回期间被保留，到账前不能用于买入，等待期间停止计息。",
  "Decision reference price": "本次决策参考价",
  "Decision reference type": "决策参考类型",
  "Actual shared fill anchor": "实际共用成交锚点",
  "Frozen recovery buy reference": "冻结的恢复买入参考",
  "USDT awaiting redemption": "赎回中的 USDT",
  "Estimated price with slippage": "含滑点的预估执行价",
  "Preflight price condition failed": "预估执行价未满足价格门槛",
  "Redemption cannot arrive before signal expiry": "赎回无法在信号过期前到账",
  "Restricted recovery activated": "已启动受限参考恢复",
  "Recovery reference expired": "恢复参考已过期",
  "Recovery ended after principal execution": "本金成交后结束参考恢复",
  "Inventory used for sizing": "本次数量计算使用的库存",
  "Benchmark": "基准",
  "Average TRX exposure": "平均 TRX 市值仓位",
  "Current research result": "当前查看的研究结果",
  "Restricted buy-reference recovery is disabled in this saved result.": "本次保存结果未启用受限买入参考恢复。",
  "Condition: restricted buy-reference recovery is enabled.": "条件：已启用受限买入参考恢复。",
  "Frozen ordinary APR: TRX 10.14%; USDGO 6.6% within this quota; USDT 7.37% for the first 300 and 2.71% thereafter (4.108% initially for 1,000 USDT). This is a current quote scenario, not historical actual rates. The backtest form keeps its manually entered assumptions.": "冻结的普通活期 APR：TRX 10.14%；本批额度内 USDGO 6.6%；USDT 前 300 枚 7.37%、其余 2.71%（1,000 USDT 初始综合年化 4.108%）。这是当前报价情景，不是历史真实利率。上方普通回测表单继续使用手动输入的研究假设。",
  "Research comparisons": "实验对比",
  "Result details": "结果明细",
  "Compare experiments, inspect results and understand each decision.": "比较研究方案，查看收益与回撤，理解每一次交易决策。",
  "Research running": "研究任务运行中",
  "Research progress": "研究任务进度",
  "TRX research navigation": "TRX 研究工作区",
  "Selected saved result": "当前选中结果",
  "View this result": "查看该结果",
  "No result selected": "尚未选择回测结果",
  "Comparison types": "实验类型",
  "Focused and controlled studies": "聚焦与受控对比",
  "Three-variant comparison": "三版本对比",
  "Mechanism and stress studies": "机制与压力验证",
  "No saved comparison batch": "暂无三版本对比批次，可在回测设置中创建。",
  "No saved mechanism study": "暂无机制验证批次，可在回测设置中运行。",
  "Equity and market chart": "权益与行情走势",
  "USDGO holdings (USDGO)": "USDGO 持有数量（USDGO）",
  "TRX holdings (TRX)": "TRX 持有数量（TRX）",
  "USDGO holdings include subscribed and redeeming balances. TRX holdings include principal and retained TRX interest. Quantities use independent axes; click legend entries to show or hide a series. Chart points are display samples from this saved continuous account.": "USDGO 数量包含已申购及赎回中的余额；TRX 数量为本金持仓＋留存 TRX 利息。数量使用独立纵轴，点击图例可显示或隐藏曲线。图表使用本次连续账户保存的展示采样点。",
  "This historical result lacks some holding snapshots. Missing points are left blank, not treated as zero.": "该历史结果缺少部分持仓快照，缺失点留空，不按零持仓处理。",
  "Capital, fees and Earn details": "资金、费用与理财明细",
  "Result records": "结果记录",
  "Executed orders": "订单成交",
  "Principal lots": "本金批次",
  "Interest credits": "理财派息",
  "View this diagnosis": "查看该次诊断",
  "This saved result has zero Earn income.": "这次保存结果未计算理财收益。",
  "Select a comparison row to inspect its saved result.": "请先在实验对比中点击“查看明细”，选择要查看的保存结果。",
  "Open a saved batch below. View details to inspect that row; new experiments use the currently selected saved result.": "下方选择已保存批次，点击“查看明细”查看对应结果；新实验以当前选中结果为基准。",
  "Rules for a new focused study": "新建聚焦实验的规则与资金假设",
  "Single-parameter controlled experiment": "单项参数受控对比",
  "Diagnostic records": "诊断记录",
  "Change unit: percentage points": "（百分点）",
  "Legacy rules under the same environment": "旧规则在新环境下的同条件对照",
  "Legacy rules: {name}": "旧规则：{name}",
  "Pressure environment: {name}": "压力环境：{name}",
  "Run legacy rules in the saved environment": "运行旧规则同条件对照",
  "Eight saved legacy rule bundles and four current alternatives share one data interval and funding environment. This compares complete rule bundles; it is not a single-factor optimization.": "八组保存的旧规则，与当前 6%、8%、合格库存出售及组合方案，在同一数据、资金和理财环境中重跑。这是整套规则对照，不是单项参数优化。",
  "Frozen environment source": "冻结环境来源",
  "Legacy study source": "旧规则来源",
  "Return and drawdown frontier": "收益与回撤的非支配方案",
  "No other executed strategy in this environment has both an equal or higher return and an equal or lower drawdown with at least one strict improvement. This does not select a live strategy; cash-only outcomes are excluded.": "同一环境内，没有其他已执行波段的方案同时满足收益不低、回撤不高且至少一项更好。这只是历史收益与回撤比较，不自动选定实盘策略；仅现金收益结果不参与。",
  "Six single-variable trading-rule experiments": "六组单变量买卖规则实验",
  "Independent two-sided funding preparation study": "独立双侧资金准备研究",
  "Run six trading-rule experiments": "运行六组买卖规则实验",
  "Run independent funding preparation study": "运行独立资金准备实验",
  "A1: 6% with profitable inventory sizing": "A1：6%＋合格库存出售",
  "B1: legacy dynamic quantity, 75% buy allocation": "B1：旧仅动态数量，买入比例降至原值 75%",
  "B2: legacy dynamic quantity, 50% buy allocation": "B2：旧仅动态数量，买入比例降至原值 50%",
  "B3: legacy dynamic quantity, profitable inventory sizing": "B3：旧仅动态数量＋合格库存出售",
  "C1: legacy dynamic period, 75% buy allocation": "C1：旧仅动态周期，买入比例降至原值 75%",
  "C2: legacy dynamic period, 50% buy allocation": "C2：旧仅动态周期，买入比例降至原值 50%",
  "Simple 40% initial TRX allocation": "初始 40% 本金买入 TRX 后持有",
  "Simple 70% initial TRX allocation": "初始 70% 本金买入 TRX 后持有",
  "Stablecoin redemption 60 minutes; TRX 1 minute": "稳定币赎回 60 分钟，TRX 1 分钟",
  "TRX redemption 60 minutes; stablecoins 1 minute": "TRX 赎回 60 分钟，稳定币 1 分钟",
  "Both sides redeem in 60 minutes": "双侧赎回均为 60 分钟",
  "Half APR, restricted quotas, both sides redeem in 60 minutes": "利率减半、额度收紧、双侧赎回 60 分钟",
  "From initial cash": "从初始现金开始",
  "After 90 continuous days": "连续回放第 90 天后切换",
  "Ordinary funding reproduction control": "普通资金环境精确复现控制",
  "Bounded funding preparation": "有界资金准备",
  "Original funding control": "原资金调度控制",
  "Continuous principal occupation and exposure": "全年连续本金占用与仓位",
  "Mean underwater principal cost": "全年平均亏损本金成本占用",
  "Peak underwater principal cost": "全年峰值亏损本金成本占用",
  "Mean principal cost held over 30 days": "全年平均持有超 30 天本金成本",
  "Peak principal cost held over 30 days": "全年峰值持有超 30 天本金成本",
  "Earn value change (USDT)": "理财收益变化（USDT）",
  "Funding conditions used for this result": "本次资金准备研究条件",
  "Ready funding hold minutes": "到账后最长等待分钟",
  "Funding cooldown minutes": "资金准备冷却分钟",
  "Continuous funding transition": "连续资金条件切换",
  "TRX research redemption delay override": "TRX 独立研究赎回等待",
  "An explicit TRX delay separates principal redemption from stablecoin redemption. An empty override inherits the general redemption delay.": "单独指定 TRX 本金的赎回等待，使其与稳定币资金分开；未指定时沿用一般赎回等待。",
  "Six predeclared single-variable rule changes use three reproduced sources and one frozen ordinary environment. Saved buy fractions and switches are retained.": "六组预先指定的单变量实验，使用三个精确复现来源和同一冻结普通环境；原买入比例及规则开关取自保存结果。",
  "Trading rules are frozen to legacy dynamic quantity. Each funding pair shares its environment; compare total equity, interest costs and drawdown within the pair. After 90 days, all lots, anchors, interest and pending funding continue without a reset.": "买卖规则冻结为旧仅动态数量，每组开关对照共用资金环境，按总权益、理财机会成本及回撤判断。第 90 天切换时，全部本金批次、锚点、利息和待到账资金连续继承，不重置账本。",
  "Underwater principal cost is capital tied to individual lots whose current sale proceeds after fees are below cost. It is not the loss amount. Old principal cost is sampled throughout the year, not only at the end.": "亏损本金成本占用按逐批扣除卖出费用后的市值低于成本计算，是被占用本金而非亏损金额。老仓成本按全年分钟记录统计，不只查看期末。",
  "Only a new confirmed signal may use arrived funding. Original signals keep their expiry, and every principal lot must still pass its net-profit check. Retained interest is excluded.": "资金实际到账后，必须出现新的确认信号才能交易；原信号不延寿，本金逐批复核净盈利，留存利息不参与普通出售。",
  "Frozen matched source batch": "冻结同条件来源批次",
  "The two study buttons use this source batch, independently of the selected detail.": "两条实验入口使用此批次的保存来源，独立于当前明细选择。",
  "The earlier parameter table describes the initial environment; this table describes conditions after the transition. Trading rules remain the same throughout.": "上方参数表记录初始环境，此处参数表记录切换后的环境；买卖规则全程保持一致。",
  "C_08": "C1 邻近检查：8% 买入比例",
  "C_10": "C1 邻近检查：10% 买入比例",
  "C1 neighbor: 8% buy allocation": "C1 邻近检查：8% 买入比例",
  "C1 neighbor: 10% buy allocation": "C1 邻近检查：10% 买入比例",
  "Candidate stability validation": "候选稳定性验证",
  "Run candidate stability validation": "运行候选稳定性验证",
  "C1 neighborhood: 8%, 9%, 10%; saved 6% and 12% context": "C1 邻近检查：8%、9%、10%；保留原 6%、12% 对照",
  "Normal one-minute redemption: preparation enabled / disabled": "普通一分钟赎回：资金准备开启／关闭",
  "After 180 continuous days": "连续回放第 180 天后切换",
  "C1 improvement from the complete continuous ledgers": "完整连续账本中的 C1 改善来源",
  "C1 minus old period source, USDT": "C1 减原旧周期来源，USDT",
  "Old period source: 12%": "原旧周期来源：12%",
  "C1: 9%": "C1：9%",
  "Realized principal profit after costs": "本金已实现净利润",
  "Ending principal mark after costs": "期末本金浮盈亏",
  "TRX interest at credited prices": "TRX 利息到账时估值",
  "Retained TRX interest price PnL": "留存 TRX 利息价格损益",
  "Realized FX profit after costs": "已实现兑换净损益",
  "Ending FX mark after costs": "期末兑换浮盈亏",
  "Principal profit already includes credited fee rebates and execution costs. Do not subtract costs again. Ending marks are separate from completed principal sales.": "本金盈亏已包含到账返费和执行成本，不能再次扣除。期末估值与已成交本金销售净利润分别列示。",
  "Only 8% and 10% are new rule parameters. The 6%, 9% and 12% rows reuse saved full ledgers. Funding independently uses old dynamic quantity, with one-minute and day-180 both-60 pairs. Hold 240 minutes, cooldown 60 minutes; no account reset or activation.": "仅新增 8%、10% 两个买入比例；6%、9%、12% 使用已保存的完整连续账本。资金线独立使用旧仅动态数量，补普通一分钟赎回和第 180 天双侧 60 分钟赎回的开启／关闭对照。保留 240 分钟、冷却 60 分钟，不重置或启动账户。",
  "Same-calendar continuous paths": "同一日历区间的连续路径",
  "Contribution": "收益贡献",
  "Change (USDT)": "变化（USDT）",
  "Charts use hourly samples; the download preserves every minute. Monthly accounts inherit all positions and retained interest. First and last months are partial; monthly calendar is Asia/Shanghai.": "图表按小时展示，下载保留每一分钟。月度账户连续继承本金和留存利息；首尾月份不完整，月度日历采用北京时间。",
  "Ending equity gap (USDT)": "月末权益差（USDT）",
  "Monthly change in gap (USDT)": "当月权益差变化（USDT）",
  "Download aligned minute paths": "下载同日期分钟路径",
  "Download monthly attribution": "下载月度归因",
  "Download actual batch differences": "下载实际批次差异",
  "Download full attribution": "下载完整归因",
  "Normal funding enabled/control: full minute paths and Earn operations identical; preparation events": "普通环境开启／关闭：全年分钟路径和理财操作一致；资金准备事件",
  "minute rows": "分钟记录",
  "Day-180 pair inherits identical held principal, anchors and retained interest.": "第 180 天成对回放继承相同的本金、锚点和留存利息。",
  "Funding preparation": "资金准备",
  "Return since the switch": "切换后区间收益",
  "Maximum drawdown since the switch": "切换后区间最大回撤",
  "Mean TRX exposure since the switch": "切换后平均 TRX 仓位",
  "Buy / sell fills since the switch": "切换后买／卖成交笔数",
  "After day 180, measure the shared window separately. Identical annual maximum drawdown can conceal different risk after the switch.": "第 180 天后单独比较同一窗口。全年最大回撤相同，也可能掩盖切换后风险不同。",
  "C2: 6%": "C2：6%",
  "Selected detail result": "当前明细结果",
  "Frozen C1 source batch": "冻结的 C1 来源批次",
  "The validation uses saved ledgers independently of the selected detail result.": "本次验证使用保存的完整账本，与当前明细结果独立。",
  "Equity": "账户权益",
  "Frozen candidates across continuous history": "冻结候选的跨区间连续验证",
  "Replay the frozen cross-period protocol": "按冻结协议重放跨区间验证",
  "Current eligible inventory sale: 8%": "当前合格库存出售：8%",
  "Longer history with a continuously inherited account": "更长历史：连续继承账户",
  "Exact reproduction from the saved original start": "原起点：精确复现控制",
  "Real historical prices plus frozen Earn conditions; historical actual product returns are not reconstructed. Four saved candidates, no funding preparation, no calendar account reset.": "真实历史价格＋冻结理财条件的研究情景，未还原历年真实产品收益。四个候选均取保存参数，不加入资金准备，不按日历重启账户。",
  "Coverage determined before new strategy results": "在查看新策略结果前确定的覆盖区间",
  "Synthetic candles": "合成 K 线",
  "Original-start controls must reproduce exactly. Earlier-start inherited accounts have different lots, costs and anchors and need not reproduce the old annual return. Original PRD defaults and the paused account remain unchanged.": "原起点控制须精确复现。更早起点继承的批次、成本和锚点不同，不要求重复原年度收益；原 PRD 默认规则和暂停账户保持原状态。",
  "Continuous paths, calendar periods and retained-interest risk": "连续路径、月年切片与留存利息风险",
  "Long-history charts use daily display points; risk and period statistics use every minute. All calendar periods inherit the same account.": "长历史图表按日抽样展示，风险和区间统计使用全部分钟记录。所有月、年报表继承同一个账户。",
  "Minutes at TRX exposure at least 80%": "TRX 仓位至少 80% 的分钟数",
  "Longest continuous high-exposure minutes": "最长连续高仓位分钟数",
  "Mean retained-interest exposure": "平均留存利息敞口",
  "Maximum retained-interest exposure": "最大留存利息敞口",
  "Ending retained-interest exposure": "期末留存利息敞口",
  "Continuous calendar slices": "连续账户日历切片",
  "Period returns use actual inherited opening equity. Drawdown is measured within the calendar window; account state is never reset. Partial first and last periods remain visible.": "区间收益以真实继承的期初权益计算，回撤在相同日历窗口内测量，账户状态不重置。首尾不完整月年仍展示。",
  "Long-history charts use daily display points; downloads preserve every minute. Passive accounts use the same frozen conditions and remain continuous.": "长历史图表按日抽样，下载保留每一分钟；被动账户采用相同冻结环境并保持连续。",
  "Original calendar year with inherited positions": "原年度日历窗口：继承老仓后的表现",
  "Inherited opening equity": "继承的期初权益（USDT）",
  "Inherited principal cost": "继承的本金成本（USDT）",
  "Inherited TRX interest": "继承的 TRX 利息数量",
  "Inherited anchor": "继承的共用锚点",
  "Download inherited calendar audit": "下载继承账户的日历对照",
  "Download month-end equity gaps": "下载月末权益差",
  "Download calendar periods": "下载日历切片",
  "Default candle data": "默认行情",
  "Extreme historical candles and execution evidence require review": "极端历史行情与成交假设待核验",
  "Official extreme candles were reproduced. C1 modeled a large purchase in a zero-volume minute at an extreme low price; historical depth and executability are unconfirmed. This return cannot establish its high-return priority.": "官方接口重查复现了极端行情。C1 曾在零成交量分钟按极端低价模拟大额买入，历史深度与可成交性尚未确认，不能凭本轮收益提高其高收益路线优先级。",
  "C1 tagged batch realized profit after credited rebates": "C1 标记批次已实现净利润（含到账返佣）",
  "Share of realized principal profit": "占全部本金已实现利润",
  "This is attribution within the preserved account path. No trades or candles were deleted; subtracting the tagged profit cannot reproduce a path without that purchase.": "这是原连续路径内的归因，未删除交易或行情。直接减去该笔利润，不能得到没有这笔买入的账户路径。",
  "Download price and execution audit": "下载行情与成交核验",
  "Cumulative return": "累计收益率",
  "Full-period continuous principal occupation and exposure": "全期连续本金占用与仓位",
  "Capital occupation is cost tied to remaining lots, not loss. Old principal is sampled across the full continuous path, not only at the end.": "本金占用是留存批次的成本，不是亏损金额；老仓成本按整段连续路径的分钟记录统计，不只查看期末。",
  "Yearly": "年度",
  "Monthly": "月度",
  "Ending equity": "期末权益",
  "C1 zero-Earn comparison across 1, 2, 3 and 5 years": "C1 零理财：1／2／3／5 年区间对比",
  "C1 fixed-APR comparison with free 1:1 FX": "C1 理财：1／2／3／5 年区间对比，USDT↔USDGO 1:1",
  "Matched zero-Earn return": "同区间零理财收益",
  "USDGO interest credited": "USDGO 已到账利息",
  "Same-scenario TRX buy-and-hold return": "同理财情景持有 TRX 收益",
  "Each start has 1,000 USDT and zero TRX. C1 rules and trading costs are frozen; TRX, USDT and USDGO Earn are disabled. Each account remains continuous within its own window.": "每个起点均为 1,000 USDT、0 TRX。C1 买卖规则及交易成本冻结，关闭 TRX、USDT、USDGO 理财；每组账户在自己的区间内连续运行。",
  "Common endpoint": "统一结束时点",
  "Different durations and opening states: cumulative returns are not a same-period strategy ranking. Annualized return uses actual elapsed time and does not mean every year earned that rate.": "各组时长、起点和后续持仓不同，累计收益不能作为同区间策略排名。复合年化按实际时长计算，不代表每年都取得这一收益。",
  "Annualized return (CAGR)": "复合年化收益",
  "Zero-Earn TRX buy-and-hold return": "同区间持有 TRX 收益",
  "{years}-year C1 without Earn": "{years} 年 C1（零理财）",
  "Reused saved one-year result": "复用已保存的 1 年结果",
  "Profits use each saved snapshot’s fees, credited rebates and slippage. Ending TRX stays marked to market without forced liquidation. The passive return uses the same window and costs. Reused results are marked individually.": "利润按各自快照的手续费、到账返佣与滑点计算。期末 TRX 按市值计入，不强制清仓。持有基准使用相同区间和费用口径；复用结果会逐行标明。",
  "Ending principal unrealized PnL": "期末本金浮盈亏",
  "TRX scenario APR": "TRX 情景年化利率",
  "USDGO scenario APR": "USDGO 情景年化利率",
  "USDT scenario APR": "USDT 情景年化利率",
  "TRX interest-bearing cap": "TRX 计息额度",
  "USDGO interest-bearing cap": "USDGO 计息额度",
  "USDGO mark in USDT": "USDGO 估值汇率",
  "FX conversion fee": "稳定币兑换手续费",
  "FX bid-ask spread": "稳定币兑换买卖价差",
  "FX conversion slippage": "稳定币兑换滑点",
  "Strategy and values saved for this run": "本次策略与参数快照",
  "Strategy actually run": "本次实际运行策略",
  "Saved mechanism combination": "快照中的机制组合",
  "Snapshot result ID": "快照结果编号",
  "Rule version": "规则版本",
  "This result belongs to one strategy run. The values below come from its saved snapshot.": "本结果只对应一套策略，下面展示该次运行保存的快照值。",
  "Dynamic thresholds": "动态门槛",
  "Dynamic confirmation periods": "动态确认周期",
  "Not recorded in this snapshot": "本快照未记录",
  "Full saved parameter snapshot": "完整参数快照（本次保存值与生效状态）",
  "TRX, USDT and USDGO Earn are all off. Any APR or savings settings retained in this snapshot do not contribute income to this run.": "TRX、USDT、USDGO 理财均关闭。快照中仍保留的利率和申赎设置，在本次回测中不参与理财收益计算。",
  "Every value below comes from the selected result snapshot. Missing historical fields are not filled with today’s defaults.": "以下值均来自当前选中结果的保存快照，历史记录缺失的字段不补入当前默认值。",
  "Earn is disabled; this saved setting is not used in this run.": "本次关闭理财，该保存值不参与本次运行计算。",
  "Snapshot identification": "快照标识或出处",
  "Recorded; applicability not documented": "已记录，适用性尚未说明",
  "Not used in this run": "本次不参与计算",
  "Inherited from strategy: enabled": "沿用本次策略：开启",
  "Inherited from strategy: disabled": "沿用本次策略：关闭",
  "Used by this run": "本次使用",
  "Saved snapshot value": "本次快照保存值",
  "Status in this run": "本次生效状态",
  "General variant reference, separate from this run": "通用版本说明（与本次运行分开）",
  "The following is general documentation about other strategy variants. It is not a list of strategies executed by this result.": "以下是其他策略版本的通用适用范围说明，不代表本次结果执行了这些版本。",
  "Original saved snapshot fields": "原始快照字段（只读）",
  "This run further adjusts the saved buy fraction using dynamic buy sizing.": "本次开启动态买入数量，会在保存的基础比例上进一步调整预算。",
  "This run uses the saved fixed buy fraction; available cash, fees and market minimums still apply.": "本次使用保存的固定买入比例，仍受可用现金、手续费和最小订单限制。",
  "This run further adjusts the saved sell fraction using dynamic sell sizing.": "本次开启动态卖出数量，会在保存的基础比例上进一步调整出售数量。",
  "This run uses the saved fixed sell fraction with its saved inventory basis; profitable-lot selection and tail completion still apply.": "本次按保存的固定卖出比例及库存口径计算目标数量，仍逐批检查盈利并处理符合条件的尾仓。",
  "Candidate periods": "候选确认周期",
  "Saved sell confirmation ceiling": "本次保存的卖出确认周期上限",
  "Replay-only sell confirmation ceiling; the original dynamic buy scheduling rule and shared transaction anchor are retained.": "本次研究单独限制卖出确认周期；买入保留原动态周期规则，成交后仍沿用共用锚点。",
  "Buy fee rate": "买入手续费率",
  "Sell fee rate": "卖出手续费率",
  "TRX hourly interest only": "仅 TRX 小时理财",
  "Fee rebate ratio": "手续费返佣比例",
  "Slippage": "交易滑点",
  "Half USDGO and half TRX at the first open": "首分钟开盘半仓 USDGO、半仓 TRX",
  "Startup allocation budgets": "启动分配预算",
  "Buy fee included": "含买入手续费",
  "Wait and Small initial purchase establish their first anchor after warmup. Half-position startup converts half the budget to USDGO and buys TRX with the other half at the first minute open; ordinary signals still wait for warmup.": "等待回撤和先买少量在预热后建立首次锚点；半仓启动在首分钟开盘把一半预算兑换 USDGO，另一半买入 TRX，普通信号仍等待原有预热完成。",
  "The startup buy budget as a fraction of deployable capital, including its fee. Small initial purchase executes after warmup; Half-position startup fixes this at 50% and executes at the first open.": "启动买入预算占可部署本金的比例，预算包含手续费。先买少量在预热后执行；半仓启动固定为 50%，在首分钟开盘执行。",
  "Condition: startup uses an initial purchase; half-position mode fixes it at 50%.": "条件：启动方式为先买少量或半仓启动；半仓启动固定为 50%。",
  "Initial purchases bypass ordinary dynamic buy sizing. Half-position startup fixes this fraction at 50% and the remaining budget goes to USDGO; small purchases use their saved fraction after warmup.": "首次买入不使用普通动态买入因子。半仓启动固定为 50%，另一半预算兑换 USDGO；先买少量在预热后使用快照保存的首次比例。",
  "Price-position sizing": "价位调节",
  "Price reference lookback": "价位参考窗口",
  "Price reference quantile": "价位参考分位数",
  "High-price buy multiplier": "高价区买入系数",
  "High-price sell multiplier": "高价区卖出系数",
  "Complete Beijing days": "个完整北京时间日",
  "Price-position research rules": "价位调节研究规则",
  "The reference is updated at Beijing midnight using only previous complete days. A signal price strictly above it scales the original sizing target; other prices and insufficient history keep the original target. Startup allocation is excluded; profitable-lot and order limits still apply.": "参考价在北京时间每日零点更新，只使用此前完整日。信号价格严格高于参考价时，才对原目标数量乘系数；其余价格及历史不足时沿用原规则。初始建仓不参与调节，盈利批次和下单限制继续生效。",
  "Enables a separate daily causal price-position sizing layer. It changes ordinary order sizes, never signal thresholds or the startup allocation.": "独立开启每日价位调节，只改变普通订单规模，不改变信号门槛和初始建仓分配。",
  "Counts previous complete Beijing calendar days. Every minute close in those days has equal weight; missing history leaves original sizing unchanged.": "统计此前完整北京时间日的全部分钟收盘价，每分钟等权；历史不足时沿用原数量规则。",
  "The selected quantile of prior minute closes. Updated only at Beijing midnight; a price equal to the reference is outside the high-price region.": "此前分钟收盘价的指定分位数，只在北京时间零点更新；价格等于参考价时不进入高价区。",
  "Multiplies the original buy budget after any dynamic quantity formula when the signal close is strictly above the daily reference.": "信号收盘价严格高于每日参考价时，在原动态数量公式计算完毕后，对买入预算乘此系数。",
  "Multiplies the original sell share after any dynamic quantity formula. The saved sell cap, available principal and profitable-lot checks still apply.": "在原动态数量公式计算完毕后，对卖出比例乘此系数；仍受快照卖出比例上限、可用本金和盈利批次检查约束。",
  "Values are read from this result snapshot. This independent research layer does not replace the original dynamic threshold, quantity or period switches.": "读取本结果保存的参数。价位调节为独立研究开关，不替代原动态门槛、数量或周期开关。",
  "Price-position sizing is disabled in this saved result.": "本结果的价位调节已关闭。",
  "Condition: price-position sizing is enabled; sufficient prior complete days are available.": "适用条件：价位调节已启用，且已有足够的此前完整日数据。",
  "Sale execution policy": "卖出执行方式",
  "Proportional principal sales": "按本金库存比例卖出",
  "Whole recent profitable added lot, then proportional core": "新增盈利批次整笔优先，清空后按比例卖底仓",
  "Each sell signal targets one newest profitable added lot remaining quantity, without the P75 sell multiplier. Startup inventory is core. Any remaining added lot, including unprofitable lots or dust, blocks core sales; a later signal with no added lots sells core proportionally. Shared anchors, confirmation periods, fees and profit checks remain; retained TRX interest is excluded.": "每个卖出信号只卖最近一个合格新增批次的实际剩余数量，不乘 P75 高价区卖出系数。初始建仓属于底仓；只要新增批次还有余额（包括亏损批次或碎仓），就不按比例卖底仓。全部新增批次售完后，后续信号才按原比例卖底仓。共用锚点、确认周期、手续费和盈利检查保留，不出售留存 TRX 利息。",
  "Proportional uses the original principal sale fraction. Recent-lot mode targets one newest profitable added lot in full; any remaining added lot blocks proportional core sales.": "比例模式使用原本金库存比例；新增批次优先模式每次以最近一个合格新增批次的全部剩余数量为目标。存在任何新增批次余额时，暂停底仓比例卖出。",
  "Added-lot quantities bypass the P75 sell multiplier and never include core or retained interest. After all added lots are sold, later signals use the original core fraction. Shared anchors and profit checks are unchanged.": "新增批次数量不乘 P75 卖出系数，不混入底仓或留存利息。新增批次全部售完后，后续信号沿用底仓原比例；共用成交锚点和盈利检查不变。",
  "Inactive: size follows the target allocation gap": "未使用：按目标仓位差额计算数量",
  "Target allocation gap, profitable principal only": "按目标仓位差额卖出，仅限盈利本金",
  "Not used: price-touch research, no candle confirmation": "不适用：价格触及研究，不等待 K 线收盘确认",
  "Saved price-event research rules": "本次保存的到价交易研究规则",
  "The execution and sizing research below overrides the corresponding legacy settings. Minute paths and full limit fills are assumptions, not recovered ticks or verified live fills.": "本研究的实际成交与数量规则以下方保存值为准，相关原参数不参与决策。分钟内顺序和限价足额成交均为假设，并非已还原的逐笔行情或已验证的实盘成交。",
  "Research execution model": "研究成交模型",
  "Pre-funded resting limit orders": "预备资金后提前挂限价单",
  "Minute touch then next eligible open": "分钟内触价，随后在可执行分钟开盘成交",
  "Research sizing model": "研究数量规则",
  "Original 12% proportional sizing": "原买入／卖出基础比例 12%",
  "Linear target allocation within +/-30%": "±30% 区间线性目标仓位",
  "Progressive target allocation within +/-30%": "±30% 区间渐进目标仓位（平方曲线）",
  "Assumed intraminute path": "假设的分钟内价格顺序",
  "Fixed allocation center": "固定区间中心价",
  "Never reset after fills": "成交后不重设区间中心",
  "Allocation range and endpoint targets": "仓位区间与边界目标",
  "TRX target 100% to 0%; profitable-lot restrictions take precedence": "TRX 目标由 100% 至 0%；盈利批次限制优先",
  "Additional limit penetration": "限价成交额外穿价条件",
  "Saved execution constraint: no fills on zero-volume minutes. Positive full-bar volume is a simulation availability assumption, not proof of open-time liquidity.": "本次保存的撮合约束：零成交量分钟不成交。整分钟正成交量只是模拟可成交性假设，不能证明开盘时有足够流动性。",
  "Underlying C1 mechanism parameters": "底层 C1 开关参数（实际研究规则见下方）",
  "Saved TRX fraction at the first open; remainder to USDGO": "首分钟开盘按快照比例买入 TRX，剩余预算兑换 USDGO",
  "At the first minute open, the saved initial fraction buys TRX including its fee; the remaining initial budget converts to USDGO. Ordinary signals retain their warmup.": "首分钟开盘按保存的首次比例买入 TRX，预算含手续费；剩余初始预算兑换 USDGO，普通信号保留原有预热。",
  "This replay uses the recorded startup fraction. It does not change the ordinary buy or sell fractions and is not a permanent position target.": "本次回放使用快照记录的首次建仓比例，不改变后续基础买卖比例，也不是持续仓位目标。",
  "Condition: saved first-open allocation startup.": "条件：按保存比例在首分钟开盘分配初始资金。",
  "Real account": "真实账户",
  "A successful read verifies data access only. Actual trading, Earn writes and arrival reconciliation still require live validation.": "读取成功只证明此项数据可访问；真实成交、理财申赎及到账对账仍需实盘验收。",
  "Real account equity and holdings": "真实账户 · 权益与持仓",
  "Observed spot equity (USDT)": "已观测现货权益（USDT）",
  "Spot TRX quantity": "现货 TRX 数量",
  "Spot USDGO quantity": "现货 USDGO 数量",
  "Spot valuation quotes": "现货估值行情",
  "Spot holdings": "现货持仓",
  "Savings holdings · 90-day creation window": "理财持仓（近90天创建）",
  "Native holding quantities": "持仓数量走势（本币）",
  "Observed spot equity values USDT, USDGO and TRX only, including frozen and locked spot balances. TRX and USDGO use fresh exchange bid quotes; USDGO is not assumed to equal USDT. Savings and UTA assets are excluded from this equity.": "现货权益仅估值 USDT、USDGO、TRX，包含现货冻结及锁定余额。TRX 和 USDGO 按交易所新鲜买一价折算，不假设 USDGO 与 USDT 恒为 1:1；理财和 UTA 资产不并入此项权益。",
  "Each explicit account read records one local observation. History survives service restarts. These observations are not strategy profit; deposits, withdrawals and manual trades can change the curve.": "每次账户读取保存一个本地观测点，服务重启后保留。快照缺失或过期时，进入本页会自动读取一次；此曲线不是策略收益，充值、提现和手动交易均可能改变余额。",
  "Account chart history could not be read or saved. Current account tables remain separate.": "账户图表历史读取或保存失败，当前账户表格仍单独展示。",
  "No account chart observations yet. Click Connect and read account to record the first point.": "尚无账户图表观测记录。点击“连接并读取账户”后保存第一个点。",
  "This observation has no complete spot valuation. Missing balances or quotes stay blank; UTA equity is not treated as spot equity.": "本次观测无法完整估值现货权益：缺失余额或行情保留为空，UTA 权益不作为现货权益。",
  "Only one observation is available. The charts show points now; later account reads will build the curves. Earlier account history is not reconstructed.": "目前只有一个观测点，图中先显示圆点；后续读取逐步形成曲线，不反推此前的账户历史。",
  "Solid lines show spot quantities; dashed lines show returned Savings holdings from orders created in the last 90 days, which may omit older holdings. Product cumulative profit is not added again. Missing observations stay blank. Click legend entries to show or hide each line.": "实线为现货数量；虚线为接口返回的近90天创建订单的理财持仓，可能不含更早持仓。产品累计收益不重复叠加；缺失数据留空。点击图例可显示或隐藏各条线。",
  "The chart shows the latest 10,000 observations; older points remain stored locally.": "图表展示最近 10,000 个观测点，更早记录仍保存在本地。",
  "Account not connected": "未连接账户",
  "Invalid local configuration": "本地配置有误",
  "Account connection disabled": "账户连接已关闭",
  "Credentials configured; connection unverified": "凭据已配置，尚未验证连接",
  "Account read completed": "账户读取完成",
  "Account read partially completed": "账户部分读取完成",
  "Account read failed": "账户读取失败",
  "Account snapshot expired": "账户快照已过期",
  "All three credential fields are required from the same source.": "API Key、Secret Key、Passphrase 三项必须来自同一配置来源且填写完整。",
  "Check the local configuration format and supported fields.": "请检查本地配置的格式与支持字段。",
  "Set the private credential file permissions to 600.": "请将私密凭据文件权限设为 600。",
  "The API key lacks permission for this read.": "API Key 缺少此项读取权限。",
  "Bitget returned 40085: UTA accounts cannot use this Classic API. Check account type and API compatibility.": "交易所返回 40085：UTA 统一账户不支持此传统查询接口，请检查账户类型与接口兼容性。",
  "Authentication failed. Check credentials, IP restrictions and account type.": "鉴权失败，请核对凭据、IP 限制及账户类型。",
  "Bitget rate limit reached. Retry later.": "触发 Bitget 频率限制，请稍后重试。",
  "Bitget request timed out or the network is unavailable.": "Bitget 请求超时或网络不可用。",
  "The exchange response could not be verified.": "交易所响应未能通过校验。",
  "Pagination could not be completed. These holdings are unavailable.": "分页读取未完成，此部分持仓暂不可用。",
  "Duplicate exchange records detected. This section is unavailable.": "检测到重复交易所记录，此部分数据暂不可用。",
  "Duplicate asset rows detected. Balances are unavailable.": "检测到重复资产记录，余额暂不可用。",
  "The exchange returned an unexpected market. This section is unavailable.": "交易所返回了非预期市场，此部分数据暂不可用。",
  "Account balances": "账户余额",
  "Open TRX/USDT orders": "TRX/USDT 未成交订单",
  "Recent TRX/USDT fills": "TRX/USDT 近期成交",
  "Flexible Savings holdings": "活期理财持仓",
  "Current flexible products": "当前活期产品",
  "Read completed": "读取完成",
  "Read failed": "读取失败",
  "Unsupported for this account type": "此账户类型尚不支持",
  "Read disabled": "未启用读取",
  "Unable to read account status. Retry after checking the local service.": "无法读取账户状态，请检查本地服务后重试。",
  "Reload local connection status": "重读本地配置状态",
  "Connect and read account": "连接并读取账户",
  "Reading account…": "正在读取账户…",
  "Read interval": "读取时间区间",
  "Snapshots expire after 60 seconds.": "快照超过 60 秒即标记过期。",
  "Local connection setup": "本地连接配置",
  "Copy config_examples/trx-bitget-readonly.example.json to the local path below and set permissions to 600.": "将 config_examples/trx-bitget-readonly.example.json 复制到下方本地路径，并将权限设为 600。",
  "Configure API Key, Secret Key and Passphrase locally. Never paste them into chat or browser storage.": "在本地配置 API Key、Secret Key 和 Passphrase，请勿粘贴到对话或浏览器存储中。",
  "Environment alternative: TRX_BITGET_API_KEY, TRX_BITGET_SECRET_KEY, TRX_BITGET_PASSPHRASE. Set all three and restart the backend.": "也可设置环境变量 TRX_BITGET_API_KEY、TRX_BITGET_SECRET_KEY、TRX_BITGET_PASSPHRASE，三项须一起设置，并重启后端。",
  "Configured account type": "配置的账户类型",
  "Credential source": "凭据来源",
  "environment": "环境变量",
  "none": "无",
  "Read verification": "读取核验",
  "UTA balances can share margin with derivatives. Available balance is not the C1 trading budget.": "UTA 余额可能与衍生品共用保证金，可用余额不能直接当作 C1 交易预算。",
  "Restricted available": "受限可用",
  "Account balance": "账户余额",
  "Account equity": "账户权益",
  "Debt": "负债",
  "Frozen": "冻结",
  "Locked": "锁定",
  "Only USDT, USDGO and TRX are shown. Missing currencies are not assumed to have zero balance.": "仅展示 USDT、USDGO 和 TRX，接口未返回的币种不推定为零余额。",
  "Only the latest 100 rows are shown. This is not a complete history or reconciliation.": "仅展示最近 100 条，不能视为完整历史或完整对账。",
  "No records returned in this query.": "本次查询范围内未返回记录。",
  "Order quantity": "委托数量",
  "Fees retain the exchange sign and original currency. Research rebates are not applied.": "手续费保留交易所返回的正负号和原币种，不套用研究返佣假设。",
  "Actual fee details": "实际费用明细",
  "BGB deduction": "BGB 抵扣",
  "Coverage: orders created in the last 90 days. Older holdings and redemption arrival remain unverified; this is not a full asset reconciliation.": "查询范围：近 90 天创建的订单。更早持仓及赎回到账尚未核查，不能视为完整资产对账。",
  "Holding quantity": "持仓数量",
  "Interest currency": "派息币种",
  "Product cumulative profit reported by API": "产品累计收益（接口值）",
  "This account cannot use this read API. Compatibility remains unverified.": "此账户无法使用该查询接口，兼容性尚未确认。",
  "The savings record type, currency or timestamp did not match the query.": "理财流水类型、币种或时间与查询范围不符，此部分数据暂不可用。",
  "The exchange returned conflicting copies of one record. This section is unavailable.": "同一流水出现冲突内容，此部分数据暂不可用。",
  "The read time budget was reached. Reduce history days and retry.": "已达到本次读取时间上限，请缩短查询天数后重试。",
  "UTA funding account balances": "UTA 资金账户余额",
  "UTA trading account balances": "UTA 统一交易账户余额",
  "Funding account Savings entries": "资金账户活期理财流水",
  "Savings subscriptions, redemptions and interest": "活期申购、赎回与派息流水",
  "Read partially completed": "部分读取完成",
  "Not applicable to this account type": "此账户类型无需单独查询",
  "Savings read compatibility pending verification": "普通活期查询兼容性待验证",
  "Savings read access confirmed for this snapshot": "本次快照已确认普通活期查询可访问",
  "Savings read access partially confirmed": "普通活期查询仅部分确认可访问",
  "Savings read access could not be confirmed": "未能确认普通活期查询可访问",
  "Savings reads disabled": "普通活期查询已关闭",
  "Subscription record": "申购记录",
  "Redemption record · arrival unverified": "赎回记录 · 到账未核实",
  "Interest payment record": "派息记录",
  "Flexible subscription funding entry": "活期申购资金流水",
  "Flexible redemption funding entry": "活期赎回资金流水",
  "Flexible interest funding entry": "活期收益资金流水",
  "Savings read adaptation is implemented. UTA uses a Savings v2 compatibility read plus separate funding-account reads.": "普通活期只读适配已加入。UTA 将尝试读取 Savings v2，并单独查询资金账户；实际权限和产品可用性待联调确认。",
  "Classic account: spot and ordinary flexible Savings use the v2 read APIs. Check the verification results below for access status.": "当前为 Classic 经典账户：现货与普通活期理财使用 v2 查询接口。各项访问状态请查看下方读取核验结果。",
  "Ordinary Savings uses the documented v2 read APIs. UTA permissions and product access must be verified with your account; no On-chain Elite product is substituted.": "普通活期使用文档所列的 v2 查询接口。UTA 的访问权限和产品可用性需用实际账户验证，不以链上精选产品替代。",
  "Trading account, funding account and Savings holdings are separate observations. They are not summed into strategy equity.": "统一交易账户、资金账户和理财持仓分别展示，不直接合计为策略权益。",
  "Balance component difference": "余额分量差额",
  "Balance components need review": "余额分量需核查",
  "Product rates and available subscription-detail fields come from the current API response. Tier limits are not personal quotas. Read access does not verify subscription eligibility, FX quotes or actual redemption arrival.": "利率及可读取的申购详情取自当前接口。利率档位上限不等于个人额度；读取成功不代表已确认申购资格、兑换报价或实际赎回到账。",
  "Per-subscription minimum / maximum": "单笔申购最小／最大数量",
  "API remaining amount": "接口返回剩余额度",
  "Subscription precision": "申购小数位数",
  "API redemption delay": "接口返回赎回时效",
  "Not provided by API": "接口未提供",
  "Interest start / settlement time": "起息／结算时间",
  "Subscription detail has not been read.": "申购详情尚未读取（每次最多读取 12 个产品详情）。",
  "Savings and funding records may describe the same event. They are not added together or credited to the strategy ledger. A redemption record alone does not verify spendable arrival.": "理财流水和资金流水可能对应同一事件，不相加计收益，也不记入策略账本。仅有赎回记录不能证明资金已可用。",
  "Record type": "流水类型",
  "Product currency": "产品币种",
  "Settlement currency": "结算币种",
  "API record amount": "接口流水金额",
  "Native funding amounts retain their sign. Per-order redemption arrival remains unverified.": "资金流水保留接口原始正负号，逐笔赎回到账仍未核实。",
  "Balance change": "余额变化",
  "Balance after entry": "变动后余额",
  "Open USDGO/USDT orders": "USDGO/USDT 未成交订单",
  "Recent USDGO/USDT fills": "USDGO/USDT 近期兑换成交",
  "Order ID": "订单号",
  "Trade ID": "成交号",
  "Filled quantity": "已成交数量",
  "UTA returns fills across spot markets. TRX/USDT and USDGO/USDT are shown separately from the latest 100 spot fills read; other pairs are excluded.": "UTA 返回跨现货市场成交；TRX/USDT 与 USDGO/USDT 分别从最近 100 条现货成交中筛选，其他币对不展示。",
  "This product subscription detail is unavailable (59012). Product rates remain visible; eligibility is unverified.": "交易所未提供此产品的申购详情（59012）；利率仍可查看，申购资格尚未确认。",
  "Trading turnover": "成交额",
  "Bitget account query snapshot": "Bitget 账户查询快照",
  "This on-demand account snapshot is separate from continuous strategy reconciliation. Reading the account does not start trading.": "此处为按需读取的交易所账户快照；策略后台持续对账请看上方“运行健康”。读取账户不会启动交易。",
  "This query snapshot is expired, not the current account balance. It does not indicate that the strategy is paused. Read again to update this section.": "本区域账户快照已过期，不能视为当前账户余额；这不代表策略暂停。点击“连接并读取账户”更新本区域。",
  "Account queries show raw exchange assets. Strategy allocation, cost basis and profit use the C1 strategy ledger.": "账户查询展示交易所原始资产；策略划拨资金、持仓成本和收益以 C1 策略账本为准。",
  "TRX live operation": "TRX 实盘运行",
  "Live operation": "实盘运行",
  "Research and validation": "研究与验证",
  "TRX console settings": "TRX 控制台设置",
  "TRX live console": "TRX 实盘控制台",
  "This console page was not found.": "未找到此控制台页面",
  "Check the address, or continue with live operation, research and validation, or settings.": "请检查网址，或前往实盘运行、研究与验证、设置。",
  "Viewing this page does not change server strategy execution.": "页面访问不会改变服务器上的策略运行。",
  "Sign in to view live operation, research and diagnostics.": "登录后查看实盘运行、研究结果与排查信息。",
  "Log in to console": "登录控制台",
  "TRX console connection": "TRX 控制台连接",
  "Log in to the TRX service with your console credentials.": "使用控制台登录凭据连接 TRX 服务。",
  "Console username": "控制台用户名",
  "Console password": "控制台密码",
  "Current service:": "当前服务：",
  "Service connection configuration": "服务连接配置",
  "The current site is used by default. Enter the service root address; /api/v1 is handled automatically.": "默认连接当前站点。填写服务根地址即可，无需附加 /api/v1。",
  "Check the service address below.": "请检查下方服务地址。",
  "Enter an HTTP(S) service address without credentials, query parameters or fragments.": "请填写 HTTP(S) 服务地址，不要包含账号密码、查询参数或片段。",
  "Enter your console username and password.": "请填写控制台用户名和密码。",
  "The service rejected these login credentials. Check the console username and password.": "登录未通过，请检查控制台用户名和密码。",
  "Unable to connect. Check the service address, network and console service, then retry.": "连接未完成，请检查服务地址、网络和控制台服务后重试。",
  "Connecting…": "正在连接…",
  "Use your console login credentials. Bitget access is managed by the server configuration.": "此处使用控制台登录凭据；Bitget 连接由服务器配置管理。",
  "Logging in connects this page. The server strategy continues with its existing positions and ledger.": "登录用于连接当前页面。服务器策略继续沿用现有持仓和账本运行。",
  "TRX console controls": "TRX 控制台工具",
  "TRX console menu": "TRX 控制台菜单",
  "Page login required": "页面需要登录",
  "Page connected": "页面已连接",
  "Page connection needs checking": "页面连接待核查",
  "Browser connection only; strategy health is shown in Live operation.": "此处仅表示页面连接；策略运行状态请查看实盘页。",
  "Refresh live data": "刷新实盘",
  "Refresh live data (read only)": "刷新实盘数据（只读）",
  "Reading…": "读取中…",
  "Updated": "已更新",
  "Retry live refresh": "刷新失败，重试",
  "Retry shortly": "正在处理，请稍后刷新",
  "Connection and display settings": "连接与显示设置",
  "Log out of this page": "退出页面登录",
  "Server strategy continues after logout.": "退出页面登录后，服务器策略继续运行。",
  "Display preferences are saved automatically in this browser.": "显示偏好自动保存在当前浏览器中。",
  "Display preferences": "显示偏好",
  "Appearance": "外观主题",
  "Timezone applies to displayed times. Execution history filters use Beijing time (UTC+8); strategy scheduling uses the server clock.": "时区用于页面时间显示；执行记录的时间筛选固定为北京时间（UTC+8），策略调度使用服务器时钟。",
  "Page connection": "页面连接",
  "Service name": "服务名称",
  "Page connection status": "页面连接状态",
  "Service address": "服务地址",
  "Configure page connection": "配置页面连接",
  "Connection needs checking": "连接待核查",
  "Connected": "已连接",
  "Not configured": "未配置",
  "Login required": "需要登录",
  "This connection controls browser access. The strategy runs independently on the server; check its health in Live operation.": "此连接用于浏览器访问服务。策略在服务器独立运行，运行状态请在“实盘运行”核查。",
  "Operation and troubleshooting": "运行与排查",
  "Live operation contains runtime health, signal decisions, balance reconciliation and the complete execution history.": "在实盘页查看运行健康、信号判断、持仓与理财对账，以及完整历史执行记录。",
  "Open live operation": "进入实盘运行与排查",
  "Strategy snapshots, product configuration, Telegram notifications and backup status are available there. Server configuration remains in effect.": "策略快照、理财产品配置、Telegram 通知和备份状态也在实盘页查看，运行继续沿用服务器配置。",
  "Loading backtest records…": "正在加载回测记录…",
  "Fetching saved batch names and dates. Your records have not been removed.": "正在读取已保存的批次名称和回测区间，请稍候。",
  "Could not load research records": "回测记录加载失败",
  "Retry loading": "重新加载",
  "Loading saved comparison…": "正在加载对比结果…",
  "The batch list is ready. Comparison summaries are loading; full ledgers load only when you open a result.": "历史批次列表已就绪，正在读取收益与风险对比；打开结果明细时才加载完整账本。",
  "Could not load this saved comparison": "此批次对比结果加载失败",
  "Loading saved result…": "正在加载回测明细…",
  "Loading this result’s parameter snapshot, chart and ledger. You can return to comparisons while waiting.": "正在读取本次回测的参数快照、图表与账本。等待期间可以返回实验对比。",
  "Could not load this saved result": "此回测明细加载失败"
}
